//Système pour promotion influenceurs via les paramètres d'URL
const queryString = window.location.search;

if (queryString) {
  console.log(queryString);
} else {
  console.log('NON');
}

function affiche(div1) {
    document.getElementById(div1).style.display = 'block'; // On affiche le bloc portant l'id associé à la variable div1
}
  
function cache(div1) {
    document.getElementById(div1).style.display = 'none'; // On affiche le bloc portant l'id associé à la variable div1
}

var initialStateVerriere = {
    version: "1.0.0",
    // Dimensions
    height: 1500,
    width: 1200,
    displayErrors: {
        errorWidthSize: false,
        errorHeightSize: false
    },
    nbTravees: 4, // = nombre de lignes
    nbTraverses: 0, // = nombre de colonnes
  	soubassement: "soubassementnon",
  	styleTravee: "1/3/4/1",

    // Type finition et couleurs
  	vitrage:'feuillete33.2',
  
  	ouvrants:'ouvrantsnon',
  	nombreouvrants:'1',
  	typeouvrants:'battant',
  	traveeouvrants1:'0000',
  	refoulementouvrants1:'refoulementgauche',
  	traveeouvrants2:'0000',
  	refoulementouvrants2:'refoulementdroite',
  	traveeouvrants3:'0000',
  	refoulementouvrants3:'refoulementgauche',
  
 	ouvrantcotecoulissant:'devant',
 	ouvrantserrurecoulissant:'serrurecoulissantnon',
 	ouvrantserrurebattant:'standard',
 	ouvrantclefbattant:'clefbattantnon',
  
    kindGlass: "transparent",
    withPeinture: true,
    withPeintureStandard: true,
    withPeintureSpecial: false,
  	withPeintureRal: false,
    kindFinitionsWithoutPeinture: "metal_brut", // Si withPeinture==false
    colorCodeWithPeinture: "9005", // Si withPeinture==true
    colorHexaWithPeinture: "#0a0a0a", // Si withPeinture==true
  	salledebain: "pashumide",
    kindFixations: "none",
  	habillage: "habillagenon",
    typeVerriere: "originale",

    // Etape sur lequel se trouve l'utilisateur
    currentStep: 1,

    // Aperçu du prix
    currentComputedPrice: null,

    // Aperçu (zone de dessin)
    canvasWidth: null,
    canvasHeight: null,
    baseImageWidth: null,
    baseImageHeight: null,
    devicePixelRatio: (window.devicePixelRatio || 1)
};

$.jCanvas.defaults.fromCenter = false;

function getMinMaxTraverse(height) {
    if (height >= 3000) {
        return {'min': 0, 'max': 15};
    } else if (height >= 2800) {
        return {'min': 0, 'max': 14};
    } else if (height >= 2600) {
        return {'min': 0, 'max': 13};
    } else if (height >= 2400) {
        return {'min': 0, 'max': 12};
    } else if (height >= 2200) {
        return {'min': 0, 'max': 11};
    } else if (height >= 2000) {
        return {'min': 0, 'max': 10};
    } else if (height >= 1800) {
        return {'min': 0, 'max': 9};
    } else if (height >= 1600) {
        return {'min': 0, 'max': 8};
    } else if (height >= 1500) {
        return {'min': 0, 'max': 7};
    } else if (height >= 1400) {
        return {'min': 0, 'max': 6};
    } else if (height >= 1200) {
        return {'min': 0, 'max': 5};
    } else if (height >= 1000) {
        return {'min': 0, 'max': 4};
    } else if (height >= 800) {
        return {'min': 0, 'max': 3};
    } else if (height >= 600) {
        return {'min': 0, 'max': 2};
    } else if (height >= 400) {
        return {'min': 0, 'max': 1};
    }

    return {'min': 0, 'max': 0};
}

function getMinMaxTravee(width) {
    if (width >= 4800) {
        return {'min': 5, 'max': 24};
    } else if (width >= 4600) {
        return {'min': 5, 'max': 23};
    } else if (width >= 4400) {
        return {'min': 5, 'max': 22};
    } else if (width >= 4200) {
        return {'min': 5, 'max': 21};
    } else if (width >= 4000) {
        return {'min': 5, 'max': 20};
    } else if (width >= 3800) {
        return {'min': 4, 'max': 19};
    } else if (width >= 3600) {
        return {'min': 4, 'max': 18};
    } else if (width >= 3400) {
        return {'min': 4, 'max': 17};
    } else if (width >= 3200) {
        return {'min': 4, 'max': 16};
    } else if (width >= 3000) {
        return {'min': 4, 'max': 15};
    } else if (width >= 2800) {
        return {'min': 3, 'max': 14};
    } else if (width >= 2600) {
        return {'min': 3, 'max': 13};
    } else if (width >= 2400) {
        return {'min': 3, 'max': 12};
    } else if (width >= 2200) {
        return {'min': 3, 'max': 11};
    } else if (width >= 2000) {
        return {'min': 3, 'max': 10};
    } else if (width >= 1800) {
        return {'min': 2, 'max': 9};
    } else if (width >= 1600) {
        return {'min': 2, 'max': 8};
    } else if (width >= 1400) {
        return {'min': 2, 'max': 7};
    } else if (width >= 1200) {
        return {'min': 1, 'max': 6};
    } else if (width >= 1000) {
        return {'min': 1, 'max': 5};
    } else if (width >= 900) {
        return {'min': 1, 'max': 4};
    } else if (width >= 800) {
        return {'min': 1, 'max': 4};
    } else if (width >= 600) {
        return {'min': 1, 'max': 3};
    } else if (width >= 400) {
        return {'min': 1, 'max': 2};
    } else if (width >= 300) {
        return {'min': 1, 'max': 2};
    }

    return {'min': 0, 'max': 0};
}

$(document).ready(function () {

    var MIN_WIDTH = 300;
    var MIN_HEIGHT = 300;
    var MAX_WIDTH = 5000;
    var MAX_HEIGHT = 2800;
	
  	
  
    var DEFAULT_COLOR = 'gray';
    var COLOR_3D_BORDER = '#7a7a7a';
    var STROKE_SIZE = 7;
  
    var currentPriceXhr = null;
  var currentPriceXhrPromo = null;
  var promoPrice = null;

    var availablePages = {};
 
//Couleurs et codes hexadeciaml
var availableColorsStandards = ["9005","9010","7016"];
var availableHexaStandards = ["#0a0a0a","#ffffff","#293133"];
   
var availableColorsNonStandards = ["9002","9003","9006","9011","9016","9017","7001","7005","7011","7024","7035","7048","1000","1001","1003","1005","1007","1012","1014","2000","2002","2004","2005","2009","2012","3000","3002","3005","3007","3013","3014","4001","4003","4006","4007","4008","4010","4011","5000","5001","5002","5005","5012","6000","6002","6005"];
var availableHexaNonStandards = ["#e7ebda","#f4f4f4","#a5a5a5","#1c1c1c","#f6f6f6","#1e1e1e","#8a9597","#646b63","#434b4d","#474a51","#d7d7d7","#898176","#bebd7f","#c2b078","#e5be01","#a98307","#dc9c00","#c7b446","#e1cc4f","#ed760e","#cb2821","#f44611","#ff2301","#f54021","#eb6a0e","#af2b1e","#a2231d","#5e2129","#412227","#a12312","#d36e70","#de4c8a","#de4c8a","#a03472","#4a192c","#924e7d","#d72d6d","#8673a1","#2a2e4b","#1f3438","#20214f","#1e2d6e","#3b83bd","#316650","#2d572c","#2f4538"];

var availableColorsSpecial = ["Érosion gentille","Argile résiliente","La Vie Sauvage","Coucher de soleil","Plateau de dune","Rouille léger","Rouille foncée","Laiton doré","Rouille véritable","Sable doré",/*,"Laiton DS-14"*/];
var availableTextureSpecial = ["erosion.jpg","argile.jpg","laviesauvage.jpg","couchersoleil.jpg","plateaudune.jpg","rouilleleger.jpg","rouillefoncee.jpg","dorerx1631.jpg","rouilleveritable.jpg","sabledore.jpg"/*"laitonds14.jpg"*/];
    
  var textMapping = {
    
        "feuillete33.2": "Feuilleté 33.2",
        "feuillete44.2": "Feuilleté 44.2",
        "phonique": "Verre phonique",
        "petitemaille": "Armé petite maille",
        "grandemaille": "Armé grande maille",
        "martele": "Martelé",
        "securitclair": "Trempé securit clair",
        "securitdepoli": "Trempé securit dépoli",
    	"bobo": "Bobo",
    	"nancy": "Nancy",
		"reims": "Reims",
    
    	"ouvrantsoui": "Oui",
    	"ouvrantsnon": "Non",
    	"battant": "Battant",
    	"coulissant": "Coulissant",

    	"refoulementgauche":"Refoulement à gauche",
    	"refoulementdroite":"Refoulement à droite",
    
    	"standard":"Standard",
    	"rouleau":"A rouleau",
    	"devant":"Devant",
    	"derriere":"Derrière",
    	"serrurecoulissantnon":"Non",
    	"serrurecoulissantoui":"Oui",
    	"clefbattantnon":"Non",
    	"clefbattantoui":"Oui",
    
        "transparent": "Transparent",
        "opale": "Opale",
        
        "metal_brut": "Métal brut",
        "metal_vernis": "Métal vernis",

        "pashumide": "Non",
        "humide": "Oui",
    
        "soubassementnon": "Non",
        "soubassementoui": "Oui",
    
        "none": "Aucune",
        "left": "A gauche",
        "right": "A droite",
        "both": "Les deux",
    
        "habillagenon": "Non",
        "habillageoui": "Oui",
    
        "originale": "Non",
        "demikit": "Oui",
    };

    // Liste des couleurs (laquages classiques)
    for (var i in availableColorsStandards) {
        var color = availableColorsStandards[i];
        var hexa = availableHexaStandards[i];
        var elem = $('<div data-bg="' + hexa + '" style="cursor: pointer; position: relative; display: inline-block; height: 50px; width: 25%; color: white; border: 2px solid transparent; border-top: 0"><div style="position: absolute; top: 0; left: 0; right: 0; bottom:0; padding: 5px; background:' + hexa + ';" data-bg="' + hexa + '">' + color + '</div></div>');

        $('#js-list-colors-standards').append(elem);
    }
  
    // Liste des couleurs (laquages Non standards)
    for (var i in availableColorsNonStandards) {
        var color = availableColorsNonStandards[i];
        var hexa = availableHexaNonStandards[i];
        var elem = $('<div data-bg="' + hexa + '" style="cursor: pointer; position: relative; display: inline-block; height: 50px; width: 25%; color: white; border: 2px solid transparent; border-top: 0"><div style="position: absolute; top: 0; left: 0; right: 0; bottom:0; padding: 5px; background:' + hexa + ';" data-bg="' + hexa + '">' + color + '</div></div>');

        $('#js-list-colors-nonstandards').append(elem);
    }
  
    // Liste des textures (laquages Spéciaux)
    for (var i in availableColorsSpecial) {
        var color = availableColorsSpecial[i];
        var hexa = availableTextureSpecial[i];
        var elem = $('<div data-bg="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/' + hexa + '" style="cursor: pointer; position: relative; display: inline-block; height: 85px; width: 33.33%; color: white; border: 2px solid transparent; border-top: 0"><div style="position: absolute; top: 0; left: 0; right: 0; bottom:0; padding: 5px; background:url(https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/' + hexa + ');background-size: cover;" data-bg="' + hexa + '">' + color + '</div></div>');

        $('#js-list-colors-special').append(elem);
    }
  
  
    // Reducer --- DEBUT
    function composerVerriere(state, action) {
        if (typeof state === 'undefined') {
            return initialStateVerriere
        }

        switch (action.type) {
            case 'VERRIERE_INIT':
                state.canvasWidth = action.canvasWidth;
                state.canvasHeight = action.canvasHeight;
                state.baseImageWidth = action.baseImageWidth;
                state.baseImageHeight = action.baseImageHeight;
                return Object.assign({}, state);
            case 'VERRIERE_CHANGE_STEP':
                state.currentStep = action.currentStep;
                return Object.assign({}, state);
            case 'VERRIERE_SET_SIZE_PRODUCT':
                state.width = action.width;
                state.height = action.height;
                return Object.assign({}, state);
            case 'VERRIERE_SET_TRAVEEE_OR_TRAVERSE':
                state.nbTravees = action.nbTravees;
                state.nbTraverses = action.nbTraverses;
                return Object.assign({}, state);
            case 'VERRIERE_SET_STYLETRAVEE':
                state.styleTravee = action.styleTravee;
                state.styleTravee = action.styleTravee;
                return Object.assign({}, state);
            case 'VERRIERE_SET_SOUBASSEMENT':
                state.soubassement = action.soubassement;
                return Object.assign({}, state);
            case 'VERRIERE_SET_KIND_GLASS':
                state.kindGlass = action.kindGlass;
                return Object.assign({}, state);
            case 'VERRIERE_TOGGLE_PEINTURE':
                state.withPeinture = action.withPeinture;
                return Object.assign({}, state);
            case 'VERRIERE_TOGGLE_PEINTURE_STANDARD':
                state.withPeintureStandard = action.withPeintureStandard;
                return Object.assign({}, state);
            case 'VERRIERE_TOGGLE_PEINTURE_SPECIAL':
                state.withPeintureSpecial = action.withPeintureSpecial;
                return Object.assign({}, state);
            case 'VERRIERE_TOGGLE_PEINTURE_RAL':
                state.withPeintureRal = action.withPeintureRal;
                return Object.assign({}, state);
            case 'VERRIERE_SET_KIND_FINITION_NO_PEINTURE':
                state.kindFinitionsWithoutPeinture = action.kindFinitionsWithoutPeinture;
                return Object.assign({}, state);
            case 'VERRIERE_SET_PEINTURE_COLOR':
                state.colorCodeWithPeinture = action.colorCodeWithPeinture;
                state.colorHexaWithPeinture = action.colorHexaWithPeinture;
                return Object.assign({}, state);
            case 'VERRIERE_SET_PEINTURE_COLOR_SPECIAL':
                state.colorCodeWithPeintureSpecial = action.colorCodeWithPeintureSpecial;
                state.colorHexaWithPeintureSpecial = action.colorHexaWithPeintureSpecial;
                return Object.assign({}, state);
            case 'VERRIERE_SET_PEINTURE_COLOR_RAL':
                state.colorCodeWithPeintureRal = action.colorCodeWithPeintureRal;
                return Object.assign({}, state);
            case 'VERRIERE_SET_SALLEDEBAIN':
                state.salledebain = action.salledebain;
                return Object.assign({}, state);
            case 'VERRIERE_SET_VITRAGE':
                state.vitrage = action.vitrage;
                return Object.assign({}, state);
            case 'VERRIERE_SET_OUVRANTS':
                state.ouvrants = action.ouvrants;
                return Object.assign({}, state);
            case 'VERRIERE_SET_NOMBREOUVRANTS':
                state.nombreouvrants = action.nombreouvrants;
                return Object.assign({}, state);
            case 'VERRIERE_SET_TYPEOUVRANTS':
                state.typeouvrants = action.typeouvrants;
                return Object.assign({}, state);
            case 'VERRIERE_SET_TRAVEEOUVRANTS1':
                state.traveeouvrants1 = action.traveeouvrants1;
                return Object.assign({}, state);
            case 'VERRIERE_SET_REFOULEMENTOUVRANTS1':
                state.refoulementouvrants1 = action.refoulementouvrants1;
                return Object.assign({}, state);
            case 'VERRIERE_SET_TRAVEEOUVRANTS2':
                state.traveeouvrants2 = action.traveeouvrants2;
                return Object.assign({}, state);
            case 'VERRIERE_SET_REFOULEMENTOUVRANTS2':
                state.refoulementouvrants2 = action.refoulementouvrants2;
                return Object.assign({}, state);
            case 'VERRIERE_SET_TRAVEEOUVRANTS3':
                state.traveeouvrants3 = action.traveeouvrants3;
                return Object.assign({}, state);
            case 'VERRIERE_SET_REFOULEMENTOUVRANTS3':
                state.refoulementouvrants3 = action.refoulementouvrants3;
                return Object.assign({}, state);
            case 'VERRIERE_SET_OUVRANTCOTECOULISSANT':
                state.ouvrantcotecoulissant = action.ouvrantcotecoulissant;
                return Object.assign({}, state);
            case 'VERRIERE_SET_OUVRANTSERRURECOULISSANT':
                state.ouvrantserrurecoulissant = action.ouvrantserrurecoulissant;
                return Object.assign({}, state);
            case 'VERRIERE_SET_OUVRANTSERRUREBATTANT':
                state.ouvrantserrurebattant = action.ouvrantserrurebattant;
                return Object.assign({}, state);
            case 'VERRIERE_SET_OUVRANTCLEFBATTANT':
                state.ouvrantclefbattant = action.ouvrantclefbattant;
                return Object.assign({}, state);
            case 'VERRIERE_SET_KIND_FIXATION':
                state.kindFixations = action.kindFixations;
                return Object.assign({}, state);
            case 'VERRIERE_SET_HABILLAGE':
                state.habillage = action.habillage;
                return Object.assign({}, state);
            case 'VERRIERE_SET_TYPE_VERRIERE':
                state.typeVerriere = action.typeVerriere;
                return Object.assign({}, state);
            case 'VERRIERE_SET_KIND_FINITION_NO_PEINTURE':
                state.kindFinitionsWithoutPeinture = action.kindFinitionsWithoutPeinture;
                return Object.assign({}, state);
            case 'VERRIERE_LOAD_SAVE':
                return Object.assign({}, action.rawSave)
            default:
                return state
        }
    }
    // Reducer --- FIN

    // Store
    var store = Redux.createStore(composerVerriere);
    if (typeof isDevMode !== "undefined" && isDevMode != null && isDevMode) {
        store = Redux.createStore(composerVerriere, isDevMode);
    } else {
        store = Redux.createStore(composerVerriere);
    }

    $(document).on('click', '.js-next-step', function () {
        var state = store.getState();

        if (state.currentStep >= 5) {
            return;
        }

        store.dispatch({
            type: 'VERRIERE_CHANGE_STEP',
            currentStep: state.currentStep + 1
        });
    });

    $(document).on('click', '.js-prev-step', function () {
        var state = store.getState();

        if (state.currentStep <= 1) {
            return;
        }

        store.dispatch({
            type: 'VERRIERE_CHANGE_STEP',
            currentStep: state.currentStep - 1
        });
    });

    $(document).on('click', '.js-step-toggle', function () {
        var state = store.getState();

        if ($(this).attr('data-step') >= state.currentStep) {
            return;
        }

        store.dispatch({
            type: 'VERRIERE_CHANGE_STEP',
            currentStep: parseInt($(this).attr('data-step'), 10)
        });
    });

    $(document).on('click', '.js-validate-size', function () {
        store.dispatch({
            type: 'VERRIERE_SET_SIZE_PRODUCT',
            width: $('#input_width').val(),
            height: $('#input_height').val()
        });
    });

    $(document).on('change', '.js-select-travee-or-traverse', function () {
        store.dispatch({
            type: 'VERRIERE_SET_TRAVEEE_OR_TRAVERSE',
            nbTravees: $('select[name=nb_travee]').val(),
            nbTraverses: $('select[name=nb_traverse]').val()
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS1',
            refoulementouvrants1: 'refoulementgauche'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: 'refoulementdroite'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS3',
            refoulementouvrants3: 'refoulementgauche'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS1',
            traveeouvrants1: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            traveeouvrants2: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: '0000'
        });
      
  		var traveeCount = $('select[name=nb_travee]').val();
        var styleTraveeChecked = "1";
		if (traveeCount == 1) {

        } else {
  			for(var i = 1; i <= traveeCount; i++) {

              		if (i == 1) {
                	} else {
          				var styleTraveeChecked = styleTraveeChecked+'/1';
                	}
 
    		}
        }

    	store.dispatch({
       		type: 'VERRIERE_SET_STYLETRAVEE',
       		styleTravee: styleTraveeChecked
    	});
    });

  
    $(document).on('click', '.js-radio-ouvrant-cote-coulissant', function () {
        store.dispatch({
            type: 'VERRIERE_SET_OUVRANTCOTECOULISSANT',
            ouvrantcotecoulissant: $('input.js-radio-ouvrant-cote-coulissant:checked').val()
        });
    });
  
    $(document).on('click', '.js-radio-ouvrant-serrure-coulissant', function () {
        store.dispatch({
            type: 'VERRIERE_SET_OUVRANTSERRURECOULISSANT',
            ouvrantserrurecoulissant: $('input.js-radio-ouvrant-serrure-coulissant:checked').val()
        });
    });
  
    $(document).on('click', '.js-radio-ouvrant-serrure-battant', function () {
        store.dispatch({
            type: 'VERRIERE_SET_OUVRANTSERRUREBATTANT',
            ouvrantserrurebattant: $('input.js-radio-ouvrant-serrure-battant:checked').val()
        });
    });
  
    $(document).on('click', '.js-radio-ouvrant-clef-battant', function () {
        store.dispatch({
            type: 'VERRIERE_SET_OUVRANTCLEFBATTANT',
            ouvrantclefbattant: $('input.js-radio-ouvrant-clef-battant:checked').val()
        });
    });
  
  
    $(document).on('click', '.js-radio-kind-glass', function () {
        store.dispatch({
            type: 'VERRIERE_SET_KIND_GLASS',
            kindGlass: $('input.js-radio-kind-glass:checked').val()
        });
    });

    $(document).on('click', '.js-radio-with-peinture', function () {
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE',
            withPeinture: $('input.js-radio-with-peinture:checked').val() == '1'
        });
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_SPECIAL',
            withPeintureSpecial: $('input.js-radio-with-peinturespecial:checked').val() == '0'
        });
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_RAL',
            withPeintureSpecial: $('input.js-radio-with-peintureral:checked').val() == '0'
        });
    });
  
    $(document).on('click', '.js-radio-with-peinturespecial', function () {
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_SPECIAL',
            withPeintureSpecial: $('input.js-radio-with-peinturespecial:checked').val() == '1'
        });
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE',
            withPeinture: $('input.js-radio-with-peinture:checked').val() == '0'
        });
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_RAL',
            withPeintureSpecial: $('input.js-radio-with-peintureral:checked').val() == '0'
        });
    });
  
    $(document).on('click', '.js-radio-with-peintureral', function () {
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_RAL',
            withPeintureRal: $('input.js-radio-with-peintureral:checked').val() == '1'
        });
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_SPECIAL',
            withPeinture: $('input.js-radio-with-peinture:checked').val() == '0'
        });
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE',
            withPeinture: $('input.js-radio-with-peinture:checked').val() == '0'
        });
    });

    $(document).on('click', '.js-radio-kind-finition-no-peinture', function () {
        store.dispatch({
            type: 'VERRIERE_SET_KIND_FINITION_NO_PEINTURE',
            kindFinitionsWithoutPeinture: $('input.js-radio-kind-finition-no-peinture:checked').val()
        });
    });
  
    $(document).on('click', '.js-btn-select-color', function () {
      
        var currentDisplay = $('#js-list-colors-standards').css('display');
      
        if (currentDisplay == 'none') {
            $('#js-list-colors-standards').css('display', 'block');
            $('#js-list-colors-nonstandards').css('display', 'block');
        } else {
            $('#js-list-colors-standards').css('display', 'none');
            $('#js-list-colors-nonstandards').css('display', 'none');
        }
    });
  
    $(document).on('click', '.js-btn-select-color-special', function () {
      
        var currentDisplaySpecial = $('#js-list-colors-special').css('display');
      
        if (currentDisplaySpecial == 'none') {
            $('#js-list-colors-special').css('display', 'block');
        } else {
            $('#js-list-colors-special').css('display', 'none');
        }
    });

    $(document).on('click', '#js-list-colors-standards > div', function () {

        $('#js-list-colors-standards').css('display', 'none');
        $('#js-list-colors-nonstandards').css('display', 'none');

        store.dispatch({
            type: 'VERRIERE_SET_PEINTURE_COLOR',
            colorCodeWithPeinture: $.trim($(this).text()),
            colorHexaWithPeinture: $(this).attr('data-bg')
        });
      
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_STANDARD',
            withPeintureStandard: $('input.js-radio-with-peinture:checked').val() == '1'
        });

    });
  
    $(document).on('click', '#js-list-colors-nonstandards > div', function () {

        $('#js-list-colors-standards').css('display', 'none');
        $('#js-list-colors-nonstandards').css('display', 'none');

        store.dispatch({
            type: 'VERRIERE_SET_PEINTURE_COLOR',
            colorCodeWithPeinture: $.trim($(this).text()),
            colorHexaWithPeinture: $(this).attr('data-bg')
        });
      
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_STANDARD',
            withPeintureStandard: $('input.js-radio-with-peinture:checked').val() == '0'
        });
    });
  
    $(document).on('click', '#js-list-colors-special > div', function () {

        $('#js-list-colors-special').css('display', 'none');
      
        store.dispatch({
            type: 'VERRIERE_SET_PEINTURE_COLOR_SPECIAL',
            colorCodeWithPeintureSpecial: $.trim($(this).text()),
            colorHexaWithPeintureSpecial: $(this).attr('data-bg')
        });
      
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_SPECIAL',
            withPeintureSpecial: $('input.js-radio-with-peinturespecial:checked').val() == '1'
        });

    });
  
    $(document).on('change', '#PeintureRalValue', function () {
      
        store.dispatch({
            type: 'VERRIERE_SET_PEINTURE_COLOR_RAL',
            colorCodeWithPeintureRal: $('#PeintureRalValue').val()
        });
      
        store.dispatch({
            type: 'VERRIERE_TOGGLE_PEINTURE_RAL',
            withPeintureRal: $('input.js-radio-with-peintureral:checked').val() == '1'
        });

    });
  
    $(document).on('click', '.js-radio-salledebain', function () {
        store.dispatch({
            type: 'VERRIERE_SET_SALLEDEBAIN',
            salledebain: $('input.js-radio-salledebain:checked').val()
        });
    });
  

  
    $(document).on('click', '#salledebain_oui', function () {
        store.dispatch({
            type: 'VERRIERE_SET_VITRAGE',
            vitrage: 'securitclair'
        });
      	document.getElementById('vitrage_securitclair').checked = true;
    });
  
    $(document).on('click', '#salledebain_non', function () {
        store.dispatch({
            type: 'VERRIERE_SET_VITRAGE',
            vitrage: 'feuillete33.2'
        });
      	document.getElementById('vitrage_33.2').checked = true;
    });
  
      $(document).on('click', '.js-radio-vitrage', function () {
        store.dispatch({
            type: 'VERRIERE_SET_VITRAGE',
            vitrage: $('input.js-radio-vitrage:checked').val()
        });
    });



$(document).on('change', '.js-styletravee', function () {
  	
  	var traveeCount = $('.js-select-travee-or-traverse').val();
  	var styleTraveeChecked = '';

  	for(var i = 1; i <= traveeCount; i++) {
		for(var i2 = 1; i2 <= 8; i2++) {
      		if(document.getElementById('styletravee'+i+'-'+i2).checked) {
              	if (styleTraveeChecked == '') {
          			var styleTraveeChecked = ''+i2+'';
                } else {
          			var styleTraveeChecked = styleTraveeChecked+'/'+i2;
                }
            }
        }
    }
 
    store.dispatch({
       type: 'VERRIERE_SET_STYLETRAVEE',
       styleTravee: styleTraveeChecked
    });
});
  
/*  
$(document).on('click', '.js-radio-refoulementouvrantsnb1', function () {
     var traveeouvrants1 = document.getElementsByClassName('js-radio-traveeouvrants-nb1');
     var traveeouvrants1FinalValue = '';
      
     //Parcours chaque input pour savoir ce qui est check ou pas
	 for(var i = 1; i <= traveeouvrants1.length; i++) {
       
       	//Fixe la valeur 1 si c'est check et 0 si c'est pas chek
      	if(document.getElementById('ouvrant-travee-nb1-'+i).checked) {
          var traveeouvrants1Value = '1';
        } else {
          var traveeouvrants1Value = '0';
        }
       
       traveeouvrants1FinalValue = traveeouvrants1FinalValue+traveeouvrants1Value;      
       
       	//Reset les ouvrants suppérieurs
       	if (document.getElementById('ouvrant-travee-nb2-'+i) != null) {
          document.getElementById('ouvrant-travee-nb2-'+i).checked = false;
       	}

       	$('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:white;');
       	$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:white;');
       	$('input#ouvrant-travee-nb2-'+i).attr('onclick', '');
		$('input#ouvrant-travee-nb3-'+i).attr('onclick', '');
	 }
  
    //Compte le nombre de box check
	var trueCount = traveeouvrants1FinalValue.split('1').length-1;
  
      	//récupère la position pour chaque séléction
		for (var i = 0; i < traveeouvrants1FinalValue.length; i++) {
      		if (traveeouvrants1FinalValue.charAt(i) == 1){
        		var trueCountPosition1 = i+1;
      		}
		}

    if (trueCount == 1) {
    	if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('onclick', 'return false;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('onclick', 'return false;');
        }
    }
  
    if (trueCount == 2) {
    	if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-4)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('onclick', 'return false;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-4)+'"]').attr('onclick', 'return false;');
        }
    }

    if (trueCount == 3) {
      if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-4)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-5)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('onclick', 'return false;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-4)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-5)+'"]').attr('onclick', 'return false;');
        }
    }
  
    	if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementdroite') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+1)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+2)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+3)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('onclick', 'return false;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+1)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+2)+'"]').attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+3)+'"]').attr('onclick', 'return false;');
        }
  
      
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            traveeouvrants2: '0000'
        });
});
  */
  
//DETECTE CHANGEMENTS TRAVEES DES OUVRANTS
    $(document).on('change', '.js-radio-traveeouvrants-nb1, .js-radio-refoulementouvrantsnb1', function () {
      
     var traveeouvrants1 = document.getElementsByClassName('js-radio-traveeouvrants-nb1');
     var traveeouvrants1FinalValue = '';
      
     //Parcours chaque input pour savoir ce qui est check ou pas
	 for(var i = 1; i <= traveeouvrants1.length; i++) {
       
       	//Fixe la valeur 1 si c'est check et 0 si c'est pas chek
      	if(document.getElementById('ouvrant-travee-nb1-'+i).checked) {
          var traveeouvrants1Value = '1';
        } else {
          var traveeouvrants1Value = '0';
        }
       
       traveeouvrants1FinalValue = traveeouvrants1FinalValue+traveeouvrants1Value;
       
       //rends tous les input uncheckable
       $('label[for="ouvrant-travee-nb1-'+i+'"]').attr('style', 'background-color:#404040;');
       $('input#ouvrant-travee-nb1-'+i).attr('onclick', 'return false;');
       
       	//Reset les ouvrants suppérieurs
       	if (document.getElementById('ouvrant-travee-nb2-'+i) != null) {
          document.getElementById('ouvrant-travee-nb2-'+i).checked = false;
       	}
       	if (document.getElementById('ouvrant-travee-nb3-'+i) != null) {
          document.getElementById('ouvrant-travee-nb3-'+i).checked = false;
       	}
       	$('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:white;');
       	$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:white;');
       	$('input#ouvrant-travee-nb2-'+i).attr('onclick', '');
		$('input#ouvrant-travee-nb3-'+i).attr('onclick', '');
	 }
      
    //Compte le nombre de box check
	var trueCount = traveeouvrants1FinalValue.split('1').length-1;
      
    //repère les positions des checkbox séléctionnées
    if (trueCount == 0) {
		for (var i = 1; i < traveeouvrants1FinalValue.length+1; i++) {
       		$('label[for="ouvrant-travee-nb1-'+i+'"]').attr('style', 'background-color:white;');
       		$('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:white;');
       		$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:white;');
       		$('input#ouvrant-travee-nb1-'+i).attr('onclick', '');
          	$('input#ouvrant-travee-nb2-'+i).attr('onclick', '');
          	$('input#ouvrant-travee-nb3-'+i).attr('onclick', '');
          
      		$('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:#b7b7b7;');
      		$('input#ouvrant-travee-nb2-'+i).attr('onclick', 'return false;');
      		$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#b7b7b7;');
      		$('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
		}
      

    } else {
      for (var i = 1; i < traveeouvrants1FinalValue.length+1; i++) {
     	$('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:white;');
      	$('input#ouvrant-travee-nb2-'+i).attr('onclick', '');
      		$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#b7b7b7;');
      		$('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
      }
    }
      
      	//récupère la position pour chaque séléction
		for (var i = 0; i < traveeouvrants1FinalValue.length; i++) {
      		if (traveeouvrants1FinalValue.charAt(i) == 1){
        		var trueCountPosition1 = i+1;
      		}
		}
    
    if (trueCount == 1) {
      	$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1+1)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1+1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1-1)).attr('onclick', '');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition1)).attr('onclick', 'return false;');
    }
      
    if (trueCount == 2) {
      	$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1+1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1+1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1-1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1-2)).attr('onclick', '');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition1-1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition1-1)).attr('onclick', 'return false;');

     
    }
      
    if (trueCount == 3) {
      	$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb1-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1-1)).attr('onclick', '');
        $('input#ouvrant-travee-nb1-'+(trueCountPosition1-2)).attr('onclick', '');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition1-1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition1-2)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition1-1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition1-2)).attr('onclick', 'return false;');
    }
      
    //système pour cacher tout ce qui est à +3 ou -3 selon le refoulement
    	if (trueCount == 1 && $('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('style', 'background-color:#404040;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1)).attr('onclick', 'return false;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1-1)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1-2)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1-3)).attr('onclick', 'return false;');
        } else if (trueCount == 2 && $('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-1)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-4)+'"]').attr('style', 'background-color:#404040;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1-1)).attr('onclick', 'return false;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1-2)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1-3)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1-4)).attr('onclick', 'return false;');
        } else if (trueCount == 3 && $('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-2)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-3)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-4)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1-5)+'"]').attr('style', 'background-color:#404040;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1-2)).attr('onclick', 'return false;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1-3)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1-4)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1-5)).attr('onclick', 'return false;');
        } else if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementdroite') {
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1)+'"]').attr('style', 'background-color:#404040;');
        	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+1)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+2)+'"]').attr('style', 'background-color:#404040;');
      		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition1+3)+'"]').attr('style', 'background-color:#404040;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1)).attr('onclick', 'return false;');
        	$('input#ouvrant-travee-nb2-'+(trueCountPosition1+1)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1+2)).attr('onclick', 'return false;');
      		$('input#ouvrant-travee-nb2-'+(trueCountPosition1+3)).attr('onclick', 'return false;');
        }

        if (trueCount == 0) {
       		store.dispatch({
            	type: 'VERRIERE_SET_TRAVEEOUVRANTS1',
            	traveeouvrants1: '0000'
        	});
        } else {
       		store.dispatch({
            	type: 'VERRIERE_SET_TRAVEEOUVRANTS1',
            	traveeouvrants1: traveeouvrants1FinalValue
        	});
        }
      
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            traveeouvrants2: '0000'
        });
      
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: '0000'
        });
      
    });
  
    $(document).on('change', '.js-radio-traveeouvrants-nb2', function () {
       
     var traveeouvrants2 = document.getElementsByClassName('js-radio-traveeouvrants-nb2');
     var traveeouvrants2FinalValue = '';
      
     //Parcours chaque input pour savoir ce qui est check ou pas dans les travées nb2
	 for(var i = 1; i <= traveeouvrants2.length; i++) {
       
       	//Fixe la valeur 1 si c'est check et 0 si c'est pas check
      	if(document.getElementById('ouvrant-travee-nb2-'+i).checked) {
          var traveeouvrants2Value = '1';
        } else {
          var traveeouvrants2Value = '0';
        }

       traveeouvrants2FinalValue = traveeouvrants2FinalValue+traveeouvrants2Value;
       
       //rends tous les input uncheckable
       $('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:#404040;');
       $('input#ouvrant-travee-nb2-'+i).attr('onclick', 'return false;');
       
       	//Reset les ouvrants suppérieurs
      	 if (document.getElementById('ouvrant-travee-nb3-'+i) != null) {
           	document.getElementById('ouvrant-travee-nb3-'+i).checked = false;
         }
       	
       	$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:white;');
		$('input#ouvrant-travee-nb3-'+i).attr('onclick', '');
	 }

    //Compte le nombre de box check
	var trueCount = traveeouvrants2FinalValue.split('1').length-1;
      
    //repère les positions des checkbox séléctionnées
    if (trueCount == 0) {
		for (var i = 1; i < traveeouvrants2FinalValue.length+1; i++) {
       		$('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:white;');
       		$('input#ouvrant-travee-nb2-'+i).attr('onclick', '');
          
      		$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#b7b7b7;');
      		$('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
		}

    } else {
      for (var i = 1; i < traveeouvrants2FinalValue.length+1; i++) {
      		$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:white;');
      		$('input#ouvrant-travee-nb3-'+i).attr('onclick', '');
      }
    }
      

      	//récupère la position pour chaque séléction
		for (var i = 0; i < traveeouvrants2FinalValue.length; i++) {
      		if (traveeouvrants2FinalValue.charAt(i) == 1){
        		var trueCountPosition2 = i+1;
      		}
		}
      
    if (trueCount == 1) {
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2+1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2-1)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2+1)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2-1)).attr('onclick', '');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition2)+'"]').attr('style', 'background-color:#404040;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition2)).attr('onclick', 'return false;');
    }
      
    if (trueCount == 2) {
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2+1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2-1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2-2)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2+1)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2-1)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2-2)).attr('onclick', '');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition2)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition2-1)+'"]').attr('style', 'background-color:#404040;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition2)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition2-1)).attr('onclick', 'return false;');
    }
      
    if (trueCount == 3) {
      	$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2-1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb2-'+(trueCountPosition2-2)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2-1)).attr('onclick', '');
        $('input#ouvrant-travee-nb2-'+(trueCountPosition2-2)).attr('onclick', '');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition2)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition2-1)+'"]').attr('style', 'background-color:#404040;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition2-2)+'"]').attr('style', 'background-color:#404040;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition2)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition2-1)).attr('onclick', 'return false;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition2-2)).attr('onclick', 'return false;');
    }
      
     //Parcours chaque input pour savoir ce qui est check ou pas dans les travées nb1
	 for(var i = 1; i <= traveeouvrants2.length; i++) {
       	//Si c'est check alors check aussi dans le nb2
      	if(document.getElementById('ouvrant-travee-nb1-'+i).checked) {
          $('label[for="ouvrant-travee-nb2-'+i+'"]').attr('style', 'background-color:#404040;');
          $('input#ouvrant-travee-nb2-'+i).attr('onclick', 'return false;');
          
      		if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementdroite') {
          		$('label[for="ouvrant-travee-nb2-'+(i+1)+'"]').attr('style', 'background-color:#404040;');
          		$('input#ouvrant-travee-nb2-'+(i+1)).attr('onclick', 'return false;');
          		$('label[for="ouvrant-travee-nb2-'+(i+2)+'"]').attr('style', 'background-color:#404040;');
          		$('input#ouvrant-travee-nb2-'+(i+2)).attr('onclick', 'return false;');
          		$('label[for="ouvrant-travee-nb2-'+(i+3)+'"]').attr('style', 'background-color:#404040;');
          		$('input#ouvrant-travee-nb2-'+(i+3)).attr('onclick', 'return false;');
      		} else if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementgauche') {
          		$('label[for="ouvrant-travee-nb2-'+(i-1)+'"]').attr('style', 'background-color:#404040;');
          		$('input#ouvrant-travee-nb2-'+(i-1)).attr('onclick', 'return false;');
          		$('label[for="ouvrant-travee-nb2-'+(i-2)+'"]').attr('style', 'background-color:#404040;');
          		$('input#ouvrant-travee-nb2-'+(i-2)).attr('onclick', 'return false;');
          		$('label[for="ouvrant-travee-nb2-'+(i-3)+'"]').attr('style', 'background-color:#404040;');
          		$('input#ouvrant-travee-nb2-'+(i-3)).attr('onclick', 'return false;');
            }
        }
       	//Si c'est check alors check aussi dans le nb3
      	if(document.getElementById('ouvrant-travee-nb1-'+i).checked) {
          $('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#404040;');
          $('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
        }
	 }

        if (trueCount == 0) {
       		store.dispatch({
            	type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            	traveeouvrants2: '0000'
        	});
        } else {
       		store.dispatch({
            	type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            	traveeouvrants2: traveeouvrants2FinalValue
        	});
        }
      
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: '0000'
        });
    });
  
    $(document).on('change', '.js-radio-traveeouvrants-nb3', function () {
      
     var traveeouvrants3 = document.getElementsByClassName('js-radio-traveeouvrants-nb3');
     var traveeouvrants3FinalValue = '';
      
     //Parcours chaque input pour savoir ce qui est check ou pas
	 for(var i = 1; i <= traveeouvrants3.length; i++) {
       
       	//Fixe la valeur 1 si c'est check et 0 si c'est pas chek
      	if(document.getElementById('ouvrant-travee-nb3-'+i).checked) {
          var traveeouvrants3Value = '1';
        } else {
          var traveeouvrants3Value = '0';
        }

       traveeouvrants3FinalValue = traveeouvrants3FinalValue+traveeouvrants3Value;
       
       //rends tous les input uncheckable
       $('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#404040;');
       $('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
       
	 }
    
    //Compte le nombre de box check
	var trueCount = traveeouvrants3FinalValue.split('1').length-1;
      
    //repère les positions des checkbox séléctionnées
    if (trueCount == 0) {
		for (var i = 1; i < traveeouvrants3FinalValue.length+1; i++) {
       		$('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:white;');
       		$('input#ouvrant-travee-nb3-'+i).attr('onclick', '');
		}
    }
      
      	//récupère la position pour chaque séléction
		for (var i = 0; i < traveeouvrants3FinalValue.length; i++) {
      		if (traveeouvrants3FinalValue.charAt(i) == 1){
        		var trueCountPosition3 = i+1;
      		}
		}
      
    if (trueCount == 1) {
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3+1)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3-1)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3+1)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3-1)).attr('onclick', '');
    }
      
    if (trueCount == 2) {
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3)+'"]').attr('style', 'background-color:white;');
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3+1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3-1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3-2)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3+1)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3-1)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3-2)).attr('onclick', '');
    }
      
    if (trueCount == 3) {
      	$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3-1)+'"]').attr('style', 'background-color:white;');
		$('label[for="ouvrant-travee-nb3-'+(trueCountPosition3-2)+'"]').attr('style', 'background-color:white;');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3-1)).attr('onclick', '');
        $('input#ouvrant-travee-nb3-'+(trueCountPosition3-2)).attr('onclick', '');
    }
      
     //Parcours chaque input pour savoir ce qui est check ou pas dans les travées nb1
	 for(var i = 1; i <= traveeouvrants3.length; i++) {
       	//Si c'est check alors check aussi dans le nb3
      	if(document.getElementById('ouvrant-travee-nb1-'+i).checked) {
          $('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#404040;');
          $('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
        }
      	if(document.getElementById('ouvrant-travee-nb2-'+i).checked) {
          $('label[for="ouvrant-travee-nb3-'+i+'"]').attr('style', 'background-color:#404040;');
          $('input#ouvrant-travee-nb3-'+i).attr('onclick', 'return false;');
        }
	 }
      
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: traveeouvrants3FinalValue
        });
      
    });
  
    $(document).on('click', '.js-radio-ouvrants', function () {
        store.dispatch({
            type: 'VERRIERE_SET_OUVRANTS',
            ouvrants: $('input.js-radio-ouvrants:checked').val()
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS1',
            refoulementouvrants1: 'refoulementgauche'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: 'refoulementdroite'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS3',
            refoulementouvrants3: 'refoulementgauche'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS1',
            traveeouvrants1: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            traveeouvrants2: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: '0000'
        });
    });
  
    $(document).on('click', '.js-radio-nombreouvrants', function () {
        store.dispatch({
            type: 'VERRIERE_SET_NOMBREOUVRANTS',
            nombreouvrants: $('input.js-radio-nombreouvrants:checked').val()
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS1',
            refoulementouvrants1: 'refoulementgauche'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: 'refoulementdroite'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS3',
            refoulementouvrants3: 'refoulementgauche'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS1',
            traveeouvrants1: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            traveeouvrants2: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: '0000'
        });
    });
  
    $(document).on('click', '.js-radio-typeouvrants', function () {
        store.dispatch({
            type: 'VERRIERE_SET_TYPEOUVRANTS',
            typeouvrants: $('input.js-radio-typeouvrants:checked').val()
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS1',
            refoulementouvrants1: 'refoulementgauche'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: 'refoulementdroite'
        });
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS3',
            refoulementouvrants3: 'refoulementgauche'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS1',
            traveeouvrants1: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS2',
            traveeouvrants2: '0000'
        });
       	store.dispatch({
            type: 'VERRIERE_SET_TRAVEEOUVRANTS3',
            traveeouvrants3: '0000'
        });
    });
  
    $(document).on('click', '.js-radio-refoulementouvrantsnb1', function () {
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS1',
            refoulementouvrants1: $('input.js-radio-refoulementouvrantsnb1:checked').val()
        });
      
      if ($('input.js-radio-refoulementouvrantsnb1:checked').val() == 'refoulementdroite') {
        $('#refoulementdroitenb2').attr('onclick', 'return false;');
        $('label[for=refoulementdroitenb2]').attr('style', 'display:none;');
        $('#refoulementgauchenb2').attr('onclick', '');
        $('label[for=refoulementgauchenb2]').attr('style', 'display:inline-block;');
        document.getElementById('refoulementgauchenb2').click();

        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: 'refoulementgauche'
        });

      } else {
        $('#refoulementgauchenb2').attr('onclick', 'return false;');
        $('label[for=refoulementgauchenb2]').attr('style', 'display:none;');
        $('#refoulementdroitenb2').attr('onclick', '');
        $('label[for=refoulementdroitenb2]').attr('style', 'display:inline-block;');
        document.getElementById('refoulementdroitenb2').click();

        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: 'refoulementdroite'
        });

      }
    });
  
    $(document).on('click', '.js-radio-refoulementouvrantsnb2', function () {
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS2',
            refoulementouvrants2: $('input.js-radio-refoulementouvrantsnb2:checked').val()
        });
    });
  
    $(document).on('click', '.js-radio-refoulementouvrantsnb3', function () {
        store.dispatch({
            type: 'VERRIERE_SET_REFOULEMENTOUVRANTS3',
            refoulementouvrants3: $('input.js-radio-refoulementouvrantsnb3:checked').val()
        });
    });

    $(document).on('click', '.js-radio-kind-fixation', function () {
        store.dispatch({
            type: 'VERRIERE_SET_KIND_FIXATION',
            kindFixations: $('input.js-radio-kind-fixation:checked').val()
        });
    });

    $(document).on('click', '.js-radio-habillage-verriere', function () {
        store.dispatch({
            type: 'VERRIERE_SET_HABILLAGE',
            habillage: $('input.js-radio-habillage-verriere:checked').val()
        });
    });
  
    $(document).on('click', '.js-radio-type-verriere', function () {
        store.dispatch({
            type: 'VERRIERE_SET_TYPE_VERRIERE',
            typeVerriere: $('input.js-radio-type-verriere:checked').val()
        });
    });
  
    /** AJOUT AU PANIER **/
    $('#js-add-to-cart').click(function () {

        $(this).prop('disabled', true);
        $('.btn').prop('disabled', true);

        var state = store.getState();

        // Génère une image du canvas, pour s'en servir comme miniature
        //var canvasImage = $('canvas:visible').eq(0).getCanvasImage();
        //state['canvasImage'] = canvasImage;
      

        $.post('https://api.mabelleverriere.fr/add-to-cart-rachel-test', state, function (data) {

          
            var propertiesProduct = {
              	'Style de la verrière': 'La Signature',
                'Largeur de baie': state.width + 'mm',
                'Hauteur de baie': state.height + 'mm',
                'Largeur jeu déduit': state.width-5 + 'mm',
                'Hauteur jeu déduit': state.height-5 + 'mm',
                'Travées': state.nbTravees,
                'Traverses': state.nbTraverses,
              	'Soubassement': textMapping[state.soubassement]
            };

          propertiesProduct['Style de verrière'] = state.styleTravee;
          
          propertiesProduct['Verrière pour salle de bain ou zone humide'] = textMapping[state.salledebain];
          
          propertiesProduct['Type de verre'] = textMapping[state.vitrage];
          
      	if (state.vitrage == 'feuillete33.2' || state.vitrage == 'feuillete44.2') {
          propertiesProduct['Transparence du verre'] = textMapping[state.kindGlass];
        }
          
            if (state.withPeintureSpecial == true) {
                propertiesProduct['Finitions'] = 'Avec peinture spéciale (' + state.colorCodeWithPeintureSpecial + ')';
            } else if (state.withPeintureRal == true) {
              	propertiesProduct['Finitions'] = 'Avec RAL sur-mesure (' + state.colorCodeWithPeintureRal + ')';
            } else if (state.withPeinture == true) {
                propertiesProduct['Finitions'] = 'Avec peinture (' + state.colorCodeWithPeinture + ')';
            } else {
                propertiesProduct['Finitions'] = 'Sans peinture (' + textMapping[state.kindFinitionsWithoutPeinture] + ')';
            }
          
          	propertiesProduct['Ouvrants'] = textMapping[state.ouvrants];
          
      	//Change nom si tirant son coulissants
if(state.typeouvrants == 'coulissant'){
      var tirantName1 = textMapping[state.refoulementouvrants1];
      var tirantName2 = textMapping[state.refoulementouvrants2];
}else {
  	if(state.refoulementouvrants1 == 'refoulementgauche'){
      var tirantName1 = 'Tirant gauche';
    } else {
      var tirantName1 = 'Tirant droite';
    }
  	if(state.refoulementouvrants2 == 'refoulementgauche'){
      var tirantName2 = 'Tirant gauche';
    } else {
      var tirantName2 = 'Tirant droite';
    }
}

          if (state.ouvrants == 'ouvrantsoui') {
          	propertiesProduct['Nombre d\'ouvrants'] = state.nombreouvrants;
          	propertiesProduct['Type d\'ouvrants'] = textMapping[state.typeouvrants];
            
      		if (state.traveeouvrants1 !== '0000') {
				propertiesProduct['Travée ouvrant 1'] = state.traveeouvrants1;
				propertiesProduct['Sens ouverture ouvrant 1'] = tirantName1;
       		 }
            
      		if (state.traveeouvrants2 !== '0000') {
                propertiesProduct['Travée ouvrant 2'] = state.traveeouvrants2;
				propertiesProduct['Sens ouverture 2'] = tirantName2;
        	}
            
      		  if (state.typeouvrants == 'battant') {
                propertiesProduct['Serrure'] = textMapping[state.ouvrantserrurebattant];
				propertiesProduct['Fermeture à clef'] = textMapping[state.ouvrantclefbattant];
      	  	  } else if(state.typeouvrants == 'coulissant') {
				propertiesProduct['Ouverture de la verrière'] = textMapping[state.ouvrantcotecoulissant];
        	  }
          }
         
          
            propertiesProduct['Fixations'] = textMapping[state.kindFixations];
          
            propertiesProduct['Cornières d\'habillage'] = textMapping[state.habillage];
          
          	propertiesProduct['Verrière divisée ?'] = textMapping[state.typeVerriere];

            try {
                data = JSON.parse(data);
            } catch (e) {}

            $.post('/cart/add.js', {
                items: [
                    {
                        quantity: 1,
                        id: data.id,
                        properties: propertiesProduct
                    }
                ]
            }, function () {
                window.location.href = '/cart';
            });
        });
    });
  
    // Mise à jour de l'interface
    store.subscribe(function () {

        var state = store.getState();

        // Elements à propos de l'etape à afficher
        $('.js-step-view').css('display', 'none');
        $('.js-step-view[data-step="' + state.currentStep + '"]').css('display', 'block');

        $('.js-step-toggle').removeClass('active');
        $('.js-step-toggle[data-step="' + state.currentStep + '"]').addClass('active');
      
      
      
    // Affiche ou cache les types de verre pour la salle de bain
	if (textMapping[state.salledebain] == 'Non') {
  		$('.js-sdb-non').css('display', 'block');
      	$('.js-sdb-oui').css('display', 'none');
	} else if (textMapping[state.salledebain] == 'Oui') {
  		$('.js-sdb-non').css('display', 'none');
      	$('.js-sdb-oui').css('display', 'block');
	}
      
    // Affiche ou cache la configuration des ouvrants
	if (state.ouvrants == 'ouvrantsoui') {
  		$('.simulateur_ouvrants').css('display', 'block');
	} else if (state.ouvrants == 'ouvrantsnon') {
  		$('.simulateur_ouvrants').css('display', 'none');
	}
      
        // Affiche les valeurs - Etape 3
        $('.js-value-width').text(state.width);
        $('.js-value-height').text(state.height);
        $('.js-value-width-deduit').text(state.width-5);
        $('.js-value-height-deduit').text(state.height-5);
        $('.js-value-travees').text(state.nbTravees);
        $('.js-value-traverses').text(state.nbTraverses);
      
      $('.js-radio-soubassement').text(textMapping[state.soubassement]);
      
      	if (state.vitrage == 'feuillete33.2' || state.vitrage == 'feuillete44.2') {
          	$('.js-value-kind-glass-display').css('display', 'block');
        	$('.js-value-kind-glass').text(textMapping[state.kindGlass]);
        } else {
          	$('.js-value-kind-glass-display').css('display', 'none');
        }
      
        if (state.withPeintureSpecial == true) {
            $('.js-value-kind-finition').text('Avec peinture spéciale (' + state.colorCodeWithPeintureSpecial + ')');
        } else if (state.withPeintureRal == true) {
            $('.js-value-kind-finition').text('Avec RAL sur-mesure (' + state.colorCodeWithPeintureRal + ')');
        } else if (state.withPeinture == true) {
            $('.js-value-kind-finition').text('Avec peinture (' + state.colorCodeWithPeinture + ')');
        } else {
            $('.js-value-kind-finition').text('Sans peinture (' + textMapping[state.kindFinitionsWithoutPeinture] + ')');
        }

        $('.js-radio-salledebain').text(textMapping[state.salledebain]);
      
        $('.js-value-ouvrants').text(textMapping[state.ouvrants]);
      
      	if (state.ouvrants == 'ouvrantsoui') {
          	$('.js-value-ouvrants-display').css('display', 'block');
        } else {
          	$('.js-value-ouvrants-display').css('display', 'none');
        }
      
        $('.js-value-nombreouvrants').text(state.nombreouvrants);
      
        $('.js-value-typeouvrants').text(textMapping[state.typeouvrants]);
        
      	//POUR TESTER VALEURS OUVRANTS TRAVEE
      	/*$('#traveeouvrantnb1value').text(state.traveeouvrants1);
      	$('#traveeouvrantnb2value').text(state.traveeouvrants2);
      	$('#traveeouvrantnb3value').text(state.traveeouvrants3);*/
      
      	if (state.traveeouvrants1 !== '0000') {
          	$('.js-value-ouvrant1-display').css('display', 'block');
       		var ouvrantTraveeResumeText1 = '';
      		var ouvrantTraveeResumeTextTemp1 = '';
      		for(var i = 0; i <= state.traveeouvrants1.length-1; i++) {
      			if(state.traveeouvrants1.charAt(i) == 1) {
         			ouvrantTraveeResumeTextTemp1 = '<label class="resumeOuvrnatTraveeYes"></label>';
       	 		} else {
        	  		ouvrantTraveeResumeTextTemp1 = '<label class="resumeOuvrnatTraveeNo"></label>';
       	 		}
            	var ouvrantTraveeResumeText1 = ouvrantTraveeResumeText1+ouvrantTraveeResumeTextTemp1;
        	}
        } else {
          	$('.js-value-ouvrant1-display').css('display', 'none');
        }
      
      	if (state.traveeouvrants2 !== '0000') {
          	$('.js-value-ouvrant2-display').css('display', 'block');
       		var ouvrantTraveeResumeText2 = '';
      		var ouvrantTraveeResumeTextTemp2 = '';
      		for(var i = 0; i <= state.traveeouvrants2.length-1; i++) {
      			if(state.traveeouvrants2.charAt(i) == 1) {
         			ouvrantTraveeResumeTextTemp2 = '<label class="resumeOuvrnatTraveeYes"></label>';
       	 		} else {
        	  		ouvrantTraveeResumeTextTemp2 = '<label class="resumeOuvrnatTraveeNo"></label>';
       	 		}
            	var ouvrantTraveeResumeText2 = ouvrantTraveeResumeText2+ouvrantTraveeResumeTextTemp2;
        	}
        } else {
          	$('.js-value-ouvrant2-display').css('display', 'none');
        }
      
      	if (state.traveeouvrants3 !== '0000') {
          	$('.js-value-ouvrant3-display').css('display', 'block');
       		var ouvrantTraveeResumeText3 = '';
      		var ouvrantTraveeResumeTextTemp3 = '';
      		for(var i = 0; i <= state.traveeouvrants3.length-1; i++) {
      			if(state.traveeouvrants3.charAt(i) == 1) {
         			ouvrantTraveeResumeTextTemp3 = '<label class="resumeOuvrnatTraveeYes"></label>';
       	 		} else {
        	  		ouvrantTraveeResumeTextTemp3 = '<label class="resumeOuvrnatTraveeNo"></label>';
       	 		}
            	var ouvrantTraveeResumeText3 = ouvrantTraveeResumeText3+ouvrantTraveeResumeTextTemp3;
        	}
        } else {
          	$('.js-value-ouvrant3-display').css('display', 'none');
        }


        $('.js-value-traveeouvrants1').html('<fieldset class="variant-input-wrap ouvrant-travee ouvrant-travee-resume">'+ouvrantTraveeResumeText1+'</fieldset>');
        $('.js-value-traveeouvrants2').html('<fieldset class="variant-input-wrap ouvrant-travee ouvrant-travee-resume">'+ouvrantTraveeResumeText2+'</fieldset>');
        $('.js-value-traveeouvrants3').html('<fieldset class="variant-input-wrap ouvrant-travee ouvrant-travee-resume">'+ouvrantTraveeResumeText3+'</fieldset>');
      
      	//Change nom si tirant son coulissants
if(state.typeouvrants == 'coulissant'){
      var tirantName1 = textMapping[state.refoulementouvrants1];
      var tirantName2 = textMapping[state.refoulementouvrants2];
      var tirantName3 = textMapping[state.refoulementouvrants3];
}else {
  	if(state.refoulementouvrants1 == 'refoulementgauche'){
      var tirantName1 = 'Poussant gauche';
    } else {
      var tirantName1 = 'Poussant droite';
    }
  	if(state.refoulementouvrants2 == 'refoulementgauche'){
      var tirantName2 = 'Poussant gauche';
    } else {
      var tirantName2 = 'Poussant droite';
    }
  	if(state.refoulementouvrants3 == 'refoulementgauche'){
      var tirantName3 = 'Poussant gauche';
    } else {
      var tirantName3 = 'Poussant droite';
    }
}
      
      
      	$('.js-value-refoulementouvrants1').text(tirantName1);
      	$('.js-value-refoulementouvrants2').text(tirantName2);
      	$('.js-value-refoulementouvrants3').text(tirantName3);
      
      	$('.js-value-ouvrantcotecoulissant').text(textMapping[state.ouvrantcotecoulissant]);
      	$('.js-value-ouvrantserrurecoulissant').text(textMapping[state.ouvrantserrurecoulissant]);
      	$('.js-value-ouvrantserrurebattant').text(textMapping[state.ouvrantserrurebattant]);
      	$('.js-value-ouvrantclefbattant').text(textMapping[state.ouvrantclefbattant]);
      
        $('.js-radio-vitrage').text(textMapping[state.vitrage]);

        $('.js-value-kind-fixation').text(textMapping[state.kindFixations]);
      
      	$('.js-value-habillage').text(textMapping[state.habillage]);
      
        $('.js-value-type-verriere').text(textMapping[state.typeVerriere]);

        // Valider les dimmensions
        var hasErrors = false;
        if (state.width < MIN_WIDTH && state.currentStep == 2 || state.width > MAX_WIDTH && state.currentStep == 2) {
            hasErrors = true;
            $('.js-error-width').css('display', 'block');
        } else {
            $('.js-error-width').css('display', 'none');
        }

        if (state.height < MIN_HEIGHT && state.currentStep == 2 || state.height > MAX_HEIGHT && state.currentStep == 2) {
            hasErrors = true;
            $('.js-error-height').css('display', 'block');
        } else {
            $('.js-error-height').css('display', 'none');
        }
        



        if (state.withPeintureSpecial == true) {
            $('.js-with-peinture').css('display', 'none');
            $('.js-without-peinture').css('display', 'none');
            $('.js-with-peinturespecial').css('display', 'block');
          	$('.js-with-peintureral').css('display', 'none');
        } else if (state.withPeintureRal == true) {
            $('.js-with-peinture').css('display', 'none');
            $('.js-without-peinture').css('display', 'none');
            $('.js-with-peinturespecial').css('display', 'none');
          	$('.js-with-peintureral').css('display', 'block');
		} else if (state.withPeinture == true) {
            $('.js-with-peinture').css('display', 'block');
            $('.js-without-peinture').css('display', 'none');
            $('.js-with-peinturespecial').css('display', 'none');
          	$('.js-with-peintureral').css('display', 'none');
        } else {
            $('.js-with-peinture').css('display', 'none');
            $('.js-without-peinture').css('display', 'block');
            $('.js-with-peinturespecial').css('display', 'block');
          	$('.js-with-peintureral').css('display', 'none');
        }
     
        if (state.colorCodeWithPeinture == null || state.colorHexaWithPeinture == null) {
            $('.js-btn-select-color')
            .css('background', '#0a0a0a')
            .text('Couleur : 9005');
        } else {
            $('.js-btn-select-color')
            .css('background', state.colorHexaWithPeinture)
            .text('Couleur : ' + state.colorCodeWithPeinture);
        }
      
        if (state.colorCodeWithPeintureSpecial == null || state.colorHexaWithPeintureSpecial == null) {
            $('.js-btn-select-color-special')
            .css('background', 'url(https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/erosion.jpg)')
            .text('Couleur : Érosion gentille');
        } else {
            $('.js-btn-select-color-special')
            .css('background', 'url(' + state.colorHexaWithPeintureSpecial + ')')
            .text('Couleur : ' + state.colorCodeWithPeintureSpecial);
        }
      
        // Détermine le min/max pour les travées et travées
        // puis ajuste les valeurs si besoin
        var minMaxTravee = getMinMaxTravee(state.width);
        $('select[name=nb_travee]').html('');
        for (var i = minMaxTravee.min; i <= minMaxTravee.max; i++) {
            var row = {
                value: i,
                text: i
            };

            if (i == state.nbTravees) {
                row['selected'] = 'selected';
            }

            $('select[name=nb_travee]').append($('<option>', row));
        }

        if (state.nbTravees > minMaxTravee.max) {
            store.dispatch({
                type: 'VERRIERE_SET_TRAVEEE_OR_TRAVERSE',
                nbTravees: minMaxTravee.max,
                nbTraverses: $('select[name=nb_traverse]').val()
            });
            // Arrêt du traitement
            return;
        }

        if (state.nbTravees < minMaxTravee.min) {
            store.dispatch({
                type: 'VERRIERE_SET_TRAVEEE_OR_TRAVERSE',
                nbTravees: minMaxTravee.min,
                nbTraverses: $('select[name=nb_traverse]').val()
            });
            // Arrêt du traitement
            return;
        }

      
        if (state.ouvrants == 'ouvrantsoui' && state.typeouvrants == 'battant') {
            $('.js-value-ouvrants-battant-equipements').css('display', 'block');
            $('.js-value-ouvrants-coulissant-equipements').css('display', 'none');
            $('.js-value-optionsportesbattantes-display').css('display', 'block');
            $('.js-value-optionsportescoulissantes-display').css('display', 'none');
        } else if(state.ouvrants == 'ouvrantsoui' && state.typeouvrants == 'coulissant') {
            $('.js-value-ouvrants-battant-equipements').css('display', 'none');
            $('.js-value-ouvrants-coulissant-equipements').css('display', 'block');
            $('.js-value-optionsportesbattantes-display').css('display', 'none');
            $('.js-value-optionsportescoulissantes-display').css('display', 'block');
        } else {
            $('.js-value-ouvrants-battant-equipements').css('display', 'none');
            $('.js-value-ouvrants-coulissant-equipements').css('display', 'none');
            $('.js-value-optionsportesbattantes-display').css('display', 'none');
            $('.js-value-optionsportescoulissantes-display').css('display', 'none');
        }

        var minMaxTraverse = getMinMaxTraverse(state.height);

          	var minTraverse = 0;
          	state.nbTraverses = 0;

      
        $('select[name=nb_traverse]').html('');
        for (var i = minTraverse; i <= minMaxTraverse.max; i++) {
            var row = {
                value: i,
                text: i
            };

            if (i == state.nbTraverses) {
                row['selected'] = 'selected';
            }

            $('select[name=nb_traverse]').append($('<option>', row));
        }
      
        if (state.nbTraverses > minMaxTraverse.max) {
            store.dispatch({
                type: 'VERRIERE_SET_TRAVEEE_OR_TRAVERSE',
                nbTravees: $('select[name=nb_travee]').val(),
                nbTraverses: minMaxTraverse.max
            });
            // Arrêt du traitement
            return;
        }

        if (state.nbTraverses < minMaxTraverse.min) {
            store.dispatch({
                type: 'VERRIERE_SET_TRAVEEE_OR_TRAVERSE',
                nbTravees: $('select[name=nb_travee]').val(),
                nbTraverses: minMaxTraverse.min
            });
            // Arrêt du traitement
            return;
        }
      	
      
//GENERE OUVRANTS
      
function ouvrantNumber( event ) {
      	//Récupère le nombre de travées et ajuste pour avoir 3 ouvrants maximum
      	if (state.nbTravees > 3) {
        	var nombreOuvrant = 2;
        } else {
          	var nombreOuvrant = state.nbTravees;
        }
          
          $('.nombre_ouvrants fieldset').html('');
      
        // Afficher le nombre d'ouvrants par rapport au nombre de travées
        for (var i = 1; i <= nombreOuvrant; i++) {
          
          if (i == 1) {
            	var row = {
              		type:'radio',
            		checked:'checked',
              		value:i,
              		name:'nombreouvrants',
              		id:'ouvrant-nb'+i,
              		autocomplete:"off",
              		class:'js-radio-nombreouvrants'
            	};
          } else {
            	var row = {
              		type:'radio',
              		value:i,
              		name:'nombreouvrants',
              		id:'ouvrant-nb'+i,
              		autocomplete:"off",
              		class:'js-radio-nombreouvrants'
            	};
          }
          
            var row2 = {
              	for:'ouvrant-nb'+i,
              	text:i
            };
          	
            $('.nombre_ouvrants fieldset').append($('<input>', row));
            $('.nombre_ouvrants fieldset').append($('<label>', row2));
    
        }
}

//FONCTION POUR GENERER OUVRANTS ET LEURS CONTENU
function ouvrantContant( event ) {
        $('.config-ouvrants-container').html('');
        //affiche le contenu pour chaque ouvrant
        for (var i = 1; i <= state.nombreouvrants; i++) {
          //initialise la variable
          
          var ouvrantTraveeText = '';
          for (var i2 = 1; i2 <= state.nbTravees; i2++) {
           
          //Fait un carré pour un travée
            //Si le carré est = au numéro de l'ouvrant alors le check

            //POUR PRE-CHECK LES CASES
            /*
            if(i == i2){
				var ouvrantTraveeTextTemp = '<input type="checkbox" checked="checked" value="ouvrant-travee-nb'+i+'-'+i2+'" name="travee-ouvrant-nb'+i+'" id="ouvrant-travee-nb'+i+'-'+i2+'" autocomplete="off" class="js-radio-traveeouvrants-nb'+i+'"><label for="ouvrant-travee-nb'+i+'-'+i2+'"></label>';
            } 
            else{
				var ouvrantTraveeTextTemp = '<input type="checkbox" value="ouvrant-travee-nb'+i+'-'+i2+'" name="travee-ouvrant-nb'+i+'" id="ouvrant-travee-nb'+i+'-'+i2+'" autocomplete="off" class="js-radio-traveeouvrants-nb'+i+'"><label for="ouvrant-travee-nb'+i+'-'+i2+'"></label>';
            }*/
            
            if(i == 1){
				var ouvrantTraveeTextTemp = '<input type="checkbox" value="ouvrant-travee-nb'+i+'-'+i2+'" name="travee-ouvrant-nb'+i+'" id="ouvrant-travee-nb'+i+'-'+i2+'" autocomplete="off" class="js-radio-traveeouvrants-nb'+i+'"><label for="ouvrant-travee-nb'+i+'-'+i2+'"></label>';
            } else {
				var ouvrantTraveeTextTemp = '<input type="checkbox" value="ouvrant-travee-nb'+i+'-'+i2+'" name="travee-ouvrant-nb'+i+'" id="ouvrant-travee-nb'+i+'-'+i2+'" autocomplete="off" class="js-radio-traveeouvrants-nb'+i+'" onclick="return false;"><label for="ouvrant-travee-nb'+i+'-'+i2+'" style="background-color:#b7b7b7;"></label>';
            }
			
            
          	//Cumule les carrés pour les affichés ensuite
            var ouvrantTraveeText = ouvrantTraveeText+ouvrantTraveeTextTemp;
          }
          
if(state.typeouvrants == 'coulissant'){
  var tirantNameGauche = 'Refoulement à gauche';
  var tirantNameDroite = 'Refoulement à droite';
}else {
  var tirantNameGauche = 'Poussant gauche';
  var tirantNameDroite = 'Poussant droite';
}
          
          if(i == 1){
			$('.config-ouvrants-container').append($('<div class="config-ouvrants-nb'+i+'"><div class="collapsibles-wrapper collapsibles-wrapper--border-bottom"><button type="button" class="label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders is-close is-open" aria-controls="ouvrantnb'+i+'" aria-expanded="true">Ouvrant n°'+i+'<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span></button><div id="ouvrantnb'+i+'" class="collapsible-content collapsible-content--all is-open" style="height: 164px;"><div class="collapsible-content__inner rte"><div class="form-vertical"><b>Travée</b><fieldset class="variant-input-wrap ouvrant-travee">'+ouvrantTraveeText+'</fieldset><b>Ouverture</b><fieldset class="variant-input-wrap simulateur_buttons"><input type="radio" checked="checked" value="refoulementgauche" name="refoulementouvrantsnb'+i+'" id="refoulementgauchenb'+i+'" autocomplete="off" class="js-radio-refoulementouvrantsnb'+i+'"><label for="refoulementgauchenb'+i+'">'+tirantNameGauche+'</label><input type="radio" value="refoulementdroite" name="refoulementouvrantsnb'+i+'" id="refoulementdroitenb'+i+'" autocomplete="off" class="js-radio-refoulementouvrantsnb'+i+'"><label for="refoulementdroitenb'+i+'">'+tirantNameDroite+'</label></fieldset></div></div></div></div></div>'));
          } else {
			$('.config-ouvrants-container').append($('<div class="config-ouvrants-nb'+i+'"><div class="collapsibles-wrapper collapsibles-wrapper--border-bottom"><button type="button" class="label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders is-close" aria-controls="ouvrantnb'+i+'" aria-expanded="false">Ouvrant n°'+i+'<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span></button><div id="ouvrantnb'+i+'" class="collapsible-content collapsible-content--all"><div class="collapsible-content__inner rte"><div class="form-vertical"><b>Travée</b><fieldset class="variant-input-wrap ouvrant-travee">'+ouvrantTraveeText+'</fieldset><b>Ouverture</b><fieldset class="variant-input-wrap simulateur_buttons"><input type="radio" value="refoulementgauche" name="refoulementouvrantsnb'+i+'" id="refoulementgauchenb'+i+'" autocomplete="off" class="js-radio-refoulementouvrantsnb'+i+'"><label for="refoulementgauchenb'+i+'" style="display:none;">'+tirantNameGauche+'</label><input type="radio" checked="checked" value="refoulementdroite" name="refoulementouvrantsnb'+i+'" id="refoulementdroitenb'+i+'" autocomplete="off" class="js-radio-refoulementouvrantsnb'+i+'"><label for="refoulementdroitenb'+i+'">'+tirantNameDroite+'</label></fieldset></div></div></div></div></div>'));
          }
          
       }
}
      
            function ouvrantResetAll() {
              	state.nombreouvrants = '1';
                ouvrantNumber();
                ouvrantContant();
            }
      
//Genere nombre ouvrants et contenu ouvrants avec les fonctions liées
$(document).on('click', '.js-radio-ouvrants', ouvrantResetAll);
$(document).on('change', '.js-radio-typeouvrants', ouvrantContant);
$(document).on('change', '.js-select-travee-or-traverse', ouvrantResetAll);
$(document).on('click', '.js-radio-nombreouvrants', ouvrantContant);    

  
//END GENERE OUVRANTS
      
        // Dessine la verriere
        var canvasBase = $('.js-base-canvas:visible');
        var canvasRatio = state.height / state.width;
        var canvasWidth = state.canvasWidth;
        var canvasHeight = state.canvasWidth * canvasRatio;

        var canvasMaxHeight = parseInt($('.js-step-view:visible .simulateur-right').width() * (state.baseImageHeight / state.baseImageWidth), 10);

        // Ajuste le canvas pour ne pas dépasser la fenêtre
        if (canvasHeight > canvasMaxHeight) {
            var canvasMaxRatioHeight = canvasMaxHeight / canvasHeight;

            canvasWidth = canvasWidth * canvasMaxRatioHeight;
            canvasHeight = canvasHeight * canvasMaxRatioHeight;
        }
      
      	// Calcule le ratio et fixe la taille pour aucune déformation
 			
      		if (canvasHeight > canvasWidth) {
      		var ratioImage = 1500/973;
        	var dynamicImageWidth = ratioImage*canvasHeight;
        	var dynamicImageHeight = canvasHeight;
              
            var ratioHeight = state.height*100/5000;
            var ratioZoom = 2-(ratioHeight*1/100);
              
        	var dynamicImageWidth = dynamicImageWidth*ratioZoom;
        	var dynamicImageHeight = dynamicImageHeight*ratioZoom;
          
            
            } else if (canvasWidth >= canvasHeight) {
      		var ratioImage = 1500/973;
        	var dynamicImageWidth = ratioImage*canvasWidth;
        	var dynamicImageHeight = canvasWidth;
              
            var ratioHeight = state.width*100/5000;
            var ratioZoom = 2-(ratioHeight*1/100);
              
        	var dynamicImageWidth = dynamicImageWidth*ratioZoom;
        	var dynamicImageHeight = dynamicImageHeight*ratioZoom;
            }
      
      /*
		if (state.height >= 2500 || state.width >= 2500 ) {
        	var dynamicImageWidth = dynamicImageWidth*1;
        	var dynamicImageHeight = dynamicImageHeight*1;
        } else if (state.height >= 2000 || state.width >= 2000 ) {
        	var dynamicImageWidth = dynamicImageWidth*1.2;
        	var dynamicImageHeight = dynamicImageHeight*1.2;
      	} else if (state.height >= 1500 || state.width >= 1500 ) {
        	var dynamicImageWidth = dynamicImageWidth*1.5;
        	var dynamicImageHeight = dynamicImageHeight*1.5;
      	} else if (state.height >= 1000 || state.width >= 1000 ) {
        	var dynamicImageWidth = dynamicImageWidth*1.7;
        	var dynamicImageHeight = dynamicImageHeight*1.7;
      	} else if (state.height >= 500 || state.width >= 500 ) {
        	var dynamicImageWidth = dynamicImageWidth*2;
        	var dynamicImageHeight = dynamicImageHeight*2;
      	}*/


        $('.js-base-canvas').attr({
            width: canvasWidth,
            height: canvasHeight
        }).css({
            width: canvasWidth + 'px !important',
            height: canvasHeight + 'px !important'
        });

        canvasBase.removeLayerGroup('canvas-base-image');

      //Image qui change de transparent à opale uniquement lorsque sdb est sur nom et que l'un des boutons est appuyé
      if (textMapping[state.salledebain] == 'Non' && (state.vitrage == 'feuillete33.2' || state.vitrage == 'feuillete44.2' )) {
       
        $('.transparence-verre-display').css('display', 'block');
        
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-' + state.kindGlass).attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      } else if (textMapping[state.salledebain] == 'Non' && state.vitrage == 'petitemaille') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-petitemaille').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      } else if (textMapping[state.salledebain] == 'Non' && state.vitrage == 'grandemaille') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-grandemaille').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      } else if (textMapping[state.salledebain] == 'Non' && state.vitrage == 'martele') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-martele').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      } else if (textMapping[state.salledebain] == 'Oui' && state.vitrage == 'securitdepoli') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-opale2').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      } else if (state.vitrage == 'bobo') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-bobo').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      }  else if (state.vitrage == 'nancy') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-nancy').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      }  else if (state.vitrage == 'reims') {
        $('.transparence-verre-display').css('display', 'none');
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-reims').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      } else {
        
        $('.transparence-verre-display').css('display', 'none');
        
        canvasBase.drawImage({
            layer: true,
            source: $('#js-image-transparent').attr('src'),
            groups: ['canvas-base-image'],
            x: (canvasWidth-dynamicImageWidth)/2,
            y: (canvasHeight-dynamicImageHeight)/2,
            width: dynamicImageWidth,
            height: dynamicImageHeight
        });
      }
      

        var colWidth = parseInt(canvasWidth / parseInt(state.nbTravees, 10), 10);
        var colHeight = parseInt(canvasHeight / (parseInt(state.nbTraverses, 10) + 1), 10);

        // D'abord, dessine les traits pour l'effet "3D"
        for (var i = 1; i <= state.nbTravees; i++) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (colWidth * i) - (STROKE_SIZE / 2), y1: 0,
                x2: (colWidth * i) - (STROKE_SIZE / 2), y2: canvasHeight
            });
        }
      
	if (state.nbTraverses == 1) {
        for (var i = 1; i <= state.nbTraverses + 1; i++) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: 0, y1: canvasHeight - ((37/100)*canvasHeight) + (STROKE_SIZE / 2),
                x2: canvasWidth, y2: canvasHeight - ((37/100)*canvasHeight) + (STROKE_SIZE / 2)
            });
        }
     } else {
        for (var i = 1; i <= state.nbTraverses + 1; i++) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: 0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: canvasWidth, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
        }
     }

        // Effet 3D sur le bord à droite
        canvasBase.drawLine({
            layer: true,
            groups: ['canvas-base-image'],
            strokeStyle: COLOR_3D_BORDER,
            strokeWidth: 4,
            x1: canvasWidth - STROKE_SIZE, y1: 0,
            x2: canvasWidth - STROKE_SIZE, y2: canvasHeight
        });

        // Effet 3D sur le bord en haut
        canvasBase.drawLine({
            layer: true,
            groups: ['canvas-base-image'],
            strokeStyle: COLOR_3D_BORDER,
            strokeWidth: 4,
            x1: 0, y1: STROKE_SIZE,
            x2: canvasWidth, y2: STROKE_SIZE,
        });

        // Dessine les lignes horizontales
      
        for (var i = 1; i <= state.nbTraverses; i++) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: 0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: canvasWidth, y2: canvasHeight - ((37/100)*canvasHeight)
            });
          
        }
      
        // Dessine les colonnes
    
        for (var i = 1; i <= state.nbTravees - 1; i++) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: colWidth * i, y1: 0,
                x2: colWidth * i, y2: canvasHeight
            });
        }
      
      
//FONCTION POUR GENERER STYLE TRAVEE
function styleTraveeContant( event ) {
  		console.log(state.nbTravees);
  		canvasBase.removeLayerGroup('canvas-base-image2').drawLayers();
  		canvasBase.removeLayerGroup('canvas-base-image3').drawLayers();
  
        $('.style-travee-container').html('');

  		var styleTraveeText = '';
          for (var i = 1; i <= state.nbTravees; i++) {
            	
            if (i==1){
				var styleTraveeTextTemp = '<div class="style-travee-nb'+i+'"><div class="collapsibles-wrapper collapsibles-wrapper--border-bottom"><button type="button" class="label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders is-close is-open" aria-controls="styletraveenb'+i+'" aria-expanded="true">Travée n°'+i+'<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span></button><div style="height: 0px;" class="collapsible-content collapsible-content--all is-open" id="styletraveenb'+i+'"><fieldset class="variant-input-wrap grid grid--small simulateur_buttons" name="style_travee" id="style_travee" style="margin: 0;"><input type="radio" checked="1" value="1" name="styletravee'+i+'" id="styletravee'+i+'-1" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-1"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_1.jpg" alt="style verriere 1" width="50"></b></label><input type="radio" value="2" name="styletravee'+i+'" id="styletravee'+i+'-2" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-2"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_2.jpg" alt="style verriere 2" width="50"></b></label><input type="radio" value="3" name="styletravee'+i+'" id="styletravee'+i+'-3" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-3"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_3.jpg" alt="style verriere 3" width="50"></b></label><input type="radio" value="4" name="styletravee'+i+'" id="styletravee'+i+'-4" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-4"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_4.jpg" alt="style verriere 4" width="50"></b></label><input type="radio" value="5" name="styletravee'+i+'" id="styletravee'+i+'-5" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-5"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_5.jpg" alt="style verriere 5" width="50"></b></label><input type="radio" value="6" name="styletravee'+i+'" id="styletravee'+i+'-6" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-6"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_6.jpg" alt="style verriere 6" width="50"></b></label><input type="radio" value="7" name="styletravee'+i+'" id="styletravee'+i+'-7" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-7"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_7.jpg" alt="style verriere 7" width="50"></b></label><input type="radio" value="8" name="styletravee'+i+'" id="styletravee'+i+'-8" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-8"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_8.jpg" alt="style verriere 8" width="50"></b></label></fieldset></div></div></div>';
            } else {
				var styleTraveeTextTemp = '<div class="style-travee-nb'+i+'"><div class="collapsibles-wrapper collapsibles-wrapper--border-bottom"><button type="button" class="label collapsible-trigger collapsible-trigger-btn collapsible-trigger-btn--borders is-close" aria-controls="styletraveenb'+i+'" aria-expanded="false">Travée n°'+i+'<span class="collapsible-trigger__icon collapsible-trigger__icon--open" role="presentation"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down" viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none" fill-rule="evenodd"></path></svg></span></button><div style="height: 0px;" class="collapsible-content collapsible-content--all" id="styletraveenb'+i+'"><fieldset class="variant-input-wrap grid grid--small simulateur_buttons" name="style_travee" id="style_travee" style="margin: 0;"><input type="radio" checked="1" value="1" name="styletravee'+i+'" id="styletravee'+i+'-1" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-1"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_1.jpg" alt="style verriere 1" width="50"></b></label><input type="radio" value="2" name="styletravee'+i+'" id="styletravee'+i+'-2" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-2"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_2.jpg" alt="style verriere 2" width="50"></b></label><input type="radio" value="3" name="styletravee'+i+'" id="styletravee'+i+'-3" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-3"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_3.jpg" alt="style verriere 3" width="50"></b></label><input type="radio" value="4" name="styletravee'+i+'" id="styletravee'+i+'-4" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-4"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_4.jpg" alt="style verriere 4" width="50"></b></label><input type="radio" value="5" name="styletravee'+i+'" id="styletravee'+i+'-5" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-5"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_5.jpg" alt="style verriere 5" width="50"></b></label><input type="radio" value="6" name="styletravee'+i+'" id="styletravee'+i+'-6" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-6"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_6.jpg" alt="style verriere 6" width="50"></b></label><input type="radio" value="7" name="styletravee'+i+'" id="styletravee'+i+'-7" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-7"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_7.jpg" alt="style verriere 7" width="50"></b></label><input type="radio" value="8" name="styletravee'+i+'" id="styletravee'+i+'-8" autocomplete="off" class="js-styletravee"><label for="styletravee'+i+'-8"><b><img src="https://cdn.shopify.com/s/files/1/0459/9532/7641/t/3/assets/style_verriere_8.jpg" alt="style verriere 8" width="50"></b></label></fieldset></div></div></div>';
            }
              	var styleTraveeText = styleTraveeText+styleTraveeTextTemp;
  		  }
  
  	var styleTraveeChecked = '';

$('.style-travee-container').append($('<div class="style-travee-container">'+styleTraveeText+'</div>'));

  
		for (var countTraveeStyle = 0; countTraveeStyle <= state.nbTravees; countTraveeStyle++) {
          
      	var arcRadiusLarge = 50;
        var arcRadiusLittle = 20;
        
          if (state.nbTravee == 1) {
      		var styleTraveePos = 0;
      		var styleTraveePosMargin = (canvasWidth/i)*(0);
            
          } else {
      		var styleTraveePos = countTraveeStyle+1;
      		var styleTraveePosMargin = (canvasWidth/i)*(styleTraveePos-1);
          }
          
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((47/100)*canvasHeight)
            	});
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
        }
  
}
      
  		canvasBase.removeLayerGroup('canvas-base-image2').drawLayers();
  		
      	var styleTraveeValues = state.styleTravee;
      	var styleTraveeSplit = [];
      	if (state.styleTravee.length == 1) {
			styleTraveeSplit = [styleTraveeValues];
        } else {
          console.log(state.styleTravee);
      	  styleTraveeSplit = styleTraveeValues.toString().split('/');
        }

		for (var countTraveeStyle = 0; countTraveeStyle <= state.nbTravees; countTraveeStyle++) {
         
      	var arcRadiusLarge = 50;
        var arcRadiusLittle = 20;
        
          if (state.nbTravee == 1) {
      		var styleTraveePos = 0;
      		var styleTraveePosMargin = (canvasWidth/i)*(0);
          } else {
      		var styleTraveePos = countTraveeStyle+1;
      		var styleTraveePosMargin = (canvasWidth/i)*(styleTraveePos-1);
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 1) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((47/100)*canvasHeight)
            	});
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 2) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i - ((18/100)*canvasWidth/i)-arcRadiusLarge, y2: canvasHeight - ((47/100)*canvasHeight)
            });
     
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+canvasWidth/i - ((18/100)*canvasWidth/i), y1: 0,
                x2: (styleTraveePosMargin)+canvasWidth/i - ((18/100)*canvasWidth/i), y2: (canvasHeight - ((47/100)*canvasHeight))-arcRadiusLarge+1
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+canvasWidth/i - ((18/100)*canvasWidth/i)-(arcRadiusLarge*2), y: (canvasHeight - ((47/100)*canvasHeight))-(arcRadiusLarge*2),
  				radius: arcRadiusLarge,
  				start: 90, end: 180
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }

          if (styleTraveeSplit[countTraveeStyle] == 3) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((18/100)*canvasWidth/i)+arcRadiusLarge, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((47/100)*canvasHeight)
            });
     
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y1: 0,
                x2: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y2: (canvasHeight - ((47/100)*canvasHeight))-arcRadiusLarge+1
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y: (canvasHeight - ((47/100)*canvasHeight))-(arcRadiusLarge*2),
  				radius: arcRadiusLarge,
  				start: 180, end: 270
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 4) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((30/100)*canvasWidth/i), y1: (canvasHeight - ((85/100)*canvasHeight))+arcRadiusLittle,
                x2: (styleTraveePosMargin)+((30/100)*canvasWidth/i), y2: (canvasHeight - ((37/100)*canvasHeight))-arcRadiusLittle
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((30/100)*canvasWidth/i)+arcRadiusLittle-1, y1: (canvasHeight - ((85/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (canvasHeight - ((85/100)*canvasHeight))
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: (canvasHeight - ((37/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+((30/100)*canvasWidth/i)-arcRadiusLittle, y2: (canvasHeight - ((37/100)*canvasHeight))
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+((30/100)*canvasWidth/i)-(arcRadiusLittle*2), y: (canvasHeight - ((37/100)*canvasHeight))-(arcRadiusLittle*2),
  				radius: arcRadiusLittle,
  				start: 90, end: 180
            });

            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+((30/100)*canvasWidth/i), y: (canvasHeight - ((85/100)*canvasHeight)),
  				radius: arcRadiusLittle,
  				start: 270, end: 360
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((47/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 5) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+canvasWidth/i-((30/100)*canvasWidth/i), y1: (canvasHeight - ((85/100)*canvasHeight))+arcRadiusLittle,
                x2: (styleTraveePosMargin)+canvasWidth/i-((30/100)*canvasWidth/i), y2: (canvasHeight - ((37/100)*canvasHeight))-arcRadiusLittle+1
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: (canvasHeight - ((85/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+canvasWidth/i-((30/100)*canvasWidth/i)-arcRadiusLittle+1, y2: (canvasHeight - ((85/100)*canvasHeight))
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+canvasWidth/i-((30/100)*canvasWidth/i)+arcRadiusLittle, y1: (canvasHeight - ((37/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (canvasHeight - ((37/100)*canvasHeight))
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+canvasWidth/i-((30/100)*canvasWidth/i), y: (canvasHeight - ((37/100)*canvasHeight))-(arcRadiusLittle*2),
  				radius: arcRadiusLittle,
  				start: 180, end: 270
            });

            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+canvasWidth/i-((30/100)*canvasWidth/i)-arcRadiusLittle*2, y: (canvasHeight - ((85/100)*canvasHeight)),
  				radius: arcRadiusLittle,
  				start: 0, end: 90
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((47/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 6) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y1: (canvasHeight - ((85/100)*canvasHeight))+arcRadiusLittle,
                x2: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y2: canvasHeight-arcRadiusLittle
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((18/100)*canvasWidth/i)+arcRadiusLittle-1, y1: (canvasHeight - ((85/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (canvasHeight - ((85/100)*canvasHeight))
            });

            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y: (canvasHeight - ((85/100)*canvasHeight)),
  				radius: arcRadiusLittle,
  				start: 270, end: 360
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y: canvasHeight-arcRadiusLittle*2,
  				radius: arcRadiusLittle,
  				start: 180, end: 270
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i), y1: (canvasHeight - ((47/100)*canvasHeight))+arcRadiusLittle-1,
                x2: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i), y2: canvasHeight
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: (canvasHeight - ((47/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i)-arcRadiusLittle+1, y2: (canvasHeight - ((47/100)*canvasHeight))
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i)-arcRadiusLittle*2, y: (canvasHeight - ((47/100)*canvasHeight)),
  				radius: arcRadiusLittle,
  				start: 0, end: 90
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 7) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i), y1: (canvasHeight - ((85/100)*canvasHeight))+arcRadiusLittle-1,
                x2: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i), y2: canvasHeight-arcRadiusLittle
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i)-arcRadiusLittle+1, y1: (canvasHeight - ((85/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+0, y2: (canvasHeight - ((85/100)*canvasHeight))
            });

            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i)-arcRadiusLittle*2, y: (canvasHeight - ((85/100)*canvasHeight)),
  				radius: arcRadiusLittle,
  				start: 0, end: 90
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+canvasWidth/i-((18/100)*canvasWidth/i)-arcRadiusLittle*2, y: canvasHeight-arcRadiusLittle*2,
  				radius: arcRadiusLittle,
  				start: 90, end: 180
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y1: (canvasHeight - ((47/100)*canvasHeight))+arcRadiusLittle-1,
                x2: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y2: canvasHeight
            });
      
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+((18/100)*canvasWidth/i)+arcRadiusLittle-1, y1: (canvasHeight - ((47/100)*canvasHeight)),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (canvasHeight - ((47/100)*canvasHeight))
            });
      
            canvasBase.drawArc({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x: (styleTraveePosMargin)+((18/100)*canvasWidth/i), y: (canvasHeight - ((47/100)*canvasHeight)),
  				radius: arcRadiusLittle,
  				start: 270, end: 360
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
          if (styleTraveeSplit[countTraveeStyle] == 8) {
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image2'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
          }
          
		}

      
$(document).on('change', '.js-select-travee-or-traverse', function () {
 	styleTraveeContant();
});
      
$(document).on('click', '.js-validate-size', function () {
  
  	//AJOUT D'UN FIX POUR AVOIR LES BONNES MESURES
  	state.nbTravees = $('select[name=nb_travee]').val();
  	state.width = $('#input_width').val();
  	state.height = $('#input_height').val();
    canvasWidth = parseInt(state.width, 10);
    canvasHeight = state.canvasWidth * (state.height / state.width);
        if (canvasHeight > canvasMaxHeight) {
            var canvasMaxRatioHeight = canvasMaxHeight / canvasHeight;
            canvasHeight = canvasHeight * canvasMaxRatioHeight;
        }
 	styleTraveeContant();
});

      
//pour afficher le selection 1/1 au chargement de la page
/*if (state.styleTravee == "1/2/3/1") {
		for (var countTraveeStyle = 0; countTraveeStyle <= 2; countTraveeStyle++) {
          
      	var arcRadiusLarge = 50;
        var arcRadiusLittle = 20;
        
          if (state.nbTravee == 1) {
      		var styleTraveePos = 0;
      		var styleTraveePosMargin = (canvasWidth/i)*(0);
            
          } else {
      		var styleTraveePos = countTraveeStyle+1;
      		var styleTraveePosMargin = (canvasWidth/i)*(styleTraveePos-1);
          }
          
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image3'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((47/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((47/100)*canvasHeight)
            	});
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image3'],
                strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
                strokeWidth: STROKE_SIZE,
                x1: (styleTraveePosMargin)+0, y1: canvasHeight - ((37/100)*canvasHeight),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: canvasHeight - ((37/100)*canvasHeight)
            });
            canvasBase.drawLine({
                layer: true,
                groups: ['canvas-base-image3'],
                strokeStyle: COLOR_3D_BORDER,
                strokeWidth: 4,
                x1: (styleTraveePosMargin)+0, y1: (colHeight * i) + (STROKE_SIZE / 2),
                x2: (styleTraveePosMargin)+canvasWidth/i, y2: (colHeight * i) + (STROKE_SIZE / 2)
            });
        }
}*/

      //Dessine visuel des ouvrants
      if (state.ouvrants == 'ouvrantsoui') {

        //Dessine pour l'ouvrant 1 si défini
      	if (state.traveeouvrants1 !== '0000') {
          
			var TraveeOuvrantNombreCheck = 0;
          	var TraveeOuvrantFirstPosition = 0;

      		for(var i = state.traveeouvrants1.length-1; i >= 0; i--) {
				if(state.traveeouvrants1.charAt(i) == 1) {
                	TraveeOuvrantNombreCheck = TraveeOuvrantNombreCheck+1;
					var TraveeOuvrantFirstPosition = i+1;
                }
        	}
          
          	var BeforeArrowSpace = (colWidth*TraveeOuvrantFirstPosition)-colWidth;
          	var TailleFleche = colWidth*TraveeOuvrantNombreCheck;
			
          	if ( state.refoulementouvrants1 == 'refoulementdroite' && state.typeouvrants == 'battant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeDash: [10],strokeWidth: 2,x1: BeforeArrowSpace+TailleFleche, y1: 0,x2: BeforeArrowSpace, y2: canvasHeight/2,x3: BeforeArrowSpace+TailleFleche, y3: canvasHeight});
            } else if(state.refoulementouvrants1 == 'refoulementgauche' && state.typeouvrants == 'battant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeDash: [10],strokeWidth: 2,x1: BeforeArrowSpace, y1: 0,x2: BeforeArrowSpace+TailleFleche, y2: canvasHeight/2,x3: BeforeArrowSpace, y3: canvasHeight});
            } else if ( state.refoulementouvrants1 == 'refoulementdroite' && state.typeouvrants == 'coulissant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeWidth: 12,rounded: true,endArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-6.2-30, y2: canvasHeight/3,});
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#fff',strokeWidth: 6,rounded: true,endArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
            } else if(state.refoulementouvrants1 == 'refoulementgauche' && state.typeouvrants == 'coulissant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeWidth: 12,rounded: true,startArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30+6.2, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#fff',strokeWidth: 6,rounded: true,startArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
            }
        }
        
        //Dessine pour l'ouvrant 2 si défini
      	if (state.traveeouvrants2 !== '0000') {
          
			var TraveeOuvrantNombreCheck = 0;
          	var TraveeOuvrantFirstPosition = 0;

      		for(var i = state.traveeouvrants2.length-1; i >= 0; i--) {
				if(state.traveeouvrants2.charAt(i) == 1) {
                	TraveeOuvrantNombreCheck = TraveeOuvrantNombreCheck+1;
					var TraveeOuvrantFirstPosition = i+1;
                }
        	}
          
          	var BeforeArrowSpace = (colWidth*TraveeOuvrantFirstPosition)-colWidth;
          	var TailleFleche = colWidth*TraveeOuvrantNombreCheck;
			
          	if ( state.refoulementouvrants2 == 'refoulementdroite' && state.typeouvrants == 'battant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeDash: [10],strokeWidth: 2,x1: BeforeArrowSpace+TailleFleche, y1: 0,x2: BeforeArrowSpace, y2: canvasHeight/2,x3: BeforeArrowSpace+TailleFleche, y3: canvasHeight});
            } else if(state.refoulementouvrants2 == 'refoulementgauche' && state.typeouvrants == 'battant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeDash: [10],strokeWidth: 2,x1: BeforeArrowSpace, y1: 0,x2: BeforeArrowSpace+TailleFleche, y2: canvasHeight/2,x3: BeforeArrowSpace, y3: canvasHeight});
            } else if ( state.refoulementouvrants2 == 'refoulementdroite' && state.typeouvrants == 'coulissant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeWidth: 12,rounded: true,endArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-6.2-30, y2: canvasHeight/3,});
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#fff',strokeWidth: 6,rounded: true,endArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
            } else if(state.refoulementouvrants2 == 'refoulementgauche' && state.typeouvrants == 'coulissant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeWidth: 12,rounded: true,startArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30+6.2, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#fff',strokeWidth: 6,rounded: true,startArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
            }
        }
        
        //Dessine pour l'ouvrant 3 si défini
      	if (state.traveeouvrants3 !== '0000') {
          
			var TraveeOuvrantNombreCheck = 0;
          	var TraveeOuvrantFirstPosition = 0;

      		for(var i = state.traveeouvrants3.length-1; i >= 0; i--) {
				if(state.traveeouvrants3.charAt(i) == 1) {
                	TraveeOuvrantNombreCheck = TraveeOuvrantNombreCheck+1;
					var TraveeOuvrantFirstPosition = i+1;
                }
        	}
          
          	var BeforeArrowSpace = (colWidth*TraveeOuvrantFirstPosition)-colWidth;
          	var TailleFleche = colWidth*TraveeOuvrantNombreCheck;
			
          	if ( state.refoulementouvrants3 == 'refoulementdroite' && state.typeouvrants == 'battant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeDash: [10],strokeWidth: 2,x1: BeforeArrowSpace+TailleFleche, y1: 0,x2: BeforeArrowSpace, y2: canvasHeight/2,x3: BeforeArrowSpace+TailleFleche, y3: canvasHeight});
            } else if(state.refoulementouvrants3 == 'refoulementgauche' && state.typeouvrants == 'battant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeDash: [10],strokeWidth: 2,x1: BeforeArrowSpace, y1: 0,x2: BeforeArrowSpace+TailleFleche, y2: canvasHeight/2,x3: BeforeArrowSpace, y3: canvasHeight});
            } else if ( state.refoulementouvrants3 == 'refoulementdroite' && state.typeouvrants == 'coulissant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeWidth: 12,rounded: true,endArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-6.2-30, y2: canvasHeight/3,});
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#fff',strokeWidth: 6,rounded: true,endArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
            } else if(state.refoulementouvrants3 == 'refoulementgauche' && state.typeouvrants == 'coulissant') {
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#000',strokeWidth: 12,rounded: true,startArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30+6.2, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
				$('canvas').drawLine({layer: true,groups: ['canvas-base-image'],strokeStyle: '#fff',strokeWidth: 6,rounded: true,startArrow: true,arrowRadius: 15,x1: BeforeArrowSpace+30, y1: canvasHeight/3,x2: BeforeArrowSpace+TailleFleche-30, y2: canvasHeight/3,});
            }
        }

      }

        // Le contour
        canvasBase.drawRect({
            layer: true,
            groups: ['canvas-base-image'],
            strokeStyle: state.withPeinture ? state.colorHexaWithPeinture : DEFAULT_COLOR,
            strokeWidth: 5,
            x: 5 / 2,
            y: 5 / 2,
            width: canvasWidth - 5,
            height: canvasHeight - 5
        });
        
        canvasBase.drawLayers();

        // Affiche l'echelle horizontal au total
        if (state.nbTravees > 1) {
            $('.js-graphic-ladder-wrapper-total-w')
            .css('width', canvasBase.width() + 'px')
            .css('display', 'block');
            $('.js-graphic-ladder-total-text-w').text(state.width + ' mm')
            .css('display', 'block');
        } else {
            $('.js-graphic-ladder-wrapper-total-w').css('display', 'none');
            $('.js-graphic-ladder-total-text-w').css('display', 'none');
        }

        // Affiche l'echelle horizontal d'un seul morceau
        var colWidthInMm = parseInt(state.width / parseInt(state.nbTravees, 10), 10);
        $('.js-graphic-ladder-wrapper-single-piece-w').css('width', colWidth + 'px');
        $('.js-graphic-ladder-single-piece-text-w').text(colWidthInMm + ' mm');

        // Affiche l'echelle vertical au total
        if (state.nbTraverses > 0) {
            $('.js-graphic-ladder-wrapper-total-h').css({
                'left': (canvasBase.width() + 40) + 'px',
                'height': canvasBase.height() + 'px'
            }).css('display', 'block');
            $('.js-graphic-ladder-total-text-h').text(state.height + ' mm')
            .css('display', 'block');
        } else {
            $('.js-graphic-ladder-wrapper-total-h').css('display', 'none');
            $('.js-graphic-ladder-total-text-h').css('display', 'none');
        }
      
        if (state.ouvrants == 'ouvrantsoui' && state.traveeouvrants1 == '0000' && state.currentStep == 4 || state.ouvrants == 'ouvrantsoui' && state.nombreouvrants == 2 && state.traveeouvrants2 == '0000' && state.currentStep == 4) {
            hasErrors = true;
            $('.js-error-ouvrants').css('display', 'block');
        } else {
            $('.js-error-ouvrants').css('display', 'none');
        }

        if (hasErrors == true) {
            $('.js-next-step').prop('disabled', true);
            $('.js-step-toggle').attr('data-disabled', '1');

            // Arrêt du traitement
            return;
        } else {
            $('.js-next-step').prop('disabled', false);
            $('.js-step-toggle').attr('data-disabled', '0');
        }

        // Affiche l'echelle vertical d'un seul morceau

		if (state.nbTraverses == 1) {
        	var colHeightInMm = parseInt(state.height-((37/100)*state.height));
        	$('.js-graphic-ladder-wrapper-single-piece-h').css({
            	'left': (canvasBase.width() + 20) + 'px',
            	'height': canvasHeight - (((37/100)*canvasHeight)) + 'px'
        	});
        	$('.js-graphic-ladder-single-piece-text-h').text(colHeightInMm + ' mm');
        } else {
            var colHeightInMm = parseInt(state.height / (parseInt(state.nbTraverses, 10) + 1), 10);
       	 	$('.js-graphic-ladder-wrapper-single-piece-h').css({
           	 'left': (canvasBase.width() + 20) + 'px',
           	 'height': colHeight + 'px'
        	});
        	$('.js-graphic-ladder-single-piece-text-h').text(colHeightInMm + ' mm');
        }
      
		if (state.currentStep == 1) {
            $('.js-prev-step').css('display', 'none');
         	$('.js-next-step').css('display', 'block');
        } else if (state.currentStep == 2) {
            $('.js-prev-step').css('display', 'block');
            $('.js-next-step').css('display', 'block');
        } else if (state.currentStep == 3) {
            $('.js-prev-step').css('display', 'block');
            $('.js-next-step').css('display', 'block');
        } else if (state.currentStep == 4) {
            $('.js-prev-step').css('display', 'block');
            $('.js-next-step').css('display', 'block');
        } else if (state.currentStep == 5) {
            $('.js-prev-step').css('display', 'block');
            $('.js-next-step').css('display', 'none');
        }
      
        // Récupère le prix HT
        var priceUrl = 'https://api.mabelleverriere.fr/p-rachel-test';
      	priceUrl += '/' + (state.styleTravee.replace(/\\|\//g,''));
        priceUrl += '/' + state.width;
        priceUrl += '/' + state.height;
        priceUrl += '/' + state.nbTravees;
        priceUrl += '/' + state.nbTraverses;
      	priceUrl += '/' + (state.soubassement == 'soubassementoui' ? '1' : '0');
        priceUrl += '/' + (state.withPeinture == true ? '1' : '0');
        priceUrl += '/' + (state.withPeintureStandard == true ? '1' : '0');
        priceUrl += '/' + (state.withPeintureSpecial == true ? '1' : '0');
        priceUrl += '/' + (state.withPeintureRal == true ? '1' : '0');
        priceUrl += '/' + (state.kindFinitionsWithoutPeinture == 'metal_vernis' ? '1' : '0');
        priceUrl += '/' + (state.kindGlass == 'opale' ? '1' : '0');
      	priceUrl += '/' + (state.salledebain == 'humide' ? '1' : '0');
      	priceUrl += '/' + (state.vitrage);
      	priceUrl += '/' + (state.ouvrants == 'ouvrantsoui' ? '1' : '0');
      	priceUrl += '/' + (state.nombreouvrants);
      	priceUrl += '/' + (state.typeouvrants == 'battant' ? '1' : '0');
      	priceUrl += '/' + (state.traveeouvrants1);
      	priceUrl += '/' + (state.traveeouvrants2);
      	priceUrl += '/' + (state.traveeouvrants3);
 		priceUrl += '/' + (state.ouvrantcotecoulissant == 'devant' ? '1' : '0');
 		priceUrl += '/' + (state.ouvrantserrurecoulissant == 'serrurecoulissantoui' ? '1' : '0');
 		priceUrl += '/' + (state.ouvrantserrurebattant == 'standard' ? '1' : '0');
 		priceUrl += '/' + (state.ouvrantclefbattant == 'clefbattantoui' ? '1' : '0');
        priceUrl += '/' + (state.habillage == "habillageoui" ? '1' : '0');
      	priceUrl += '/' + (state.typeVerriere == 'demikit' ? '1' : '0');

        if (currentPriceXhr != null) {
            currentPriceXhr.abort();
        }

        currentPriceXhr = $.get(priceUrl, function (data) {
            $('.js-value-price').text(parseFloat(data).toFixed(0));
        });
      
      	//Prix pour promotion s'il y en a une
        if (currentPriceXhrPromo != null) {
            currentPriceXhrPromo.abort();
        }

        currentPriceXhrPromo = $.get(priceUrl, function (data) {
          promoPrice = parseFloat(data).toFixed(2);
          promoPrice = promoPrice-(promoPrice*25/100);
            $('.js-value-price-promo').text(parseFloat(promoPrice).toFixed(0));
        });
      //fin prix promo
    });
  
    // L'application démarre ici
    var imageBase = new Image();
    imageBase.onload = function () {

        var baseWidth = $('.simulateur-right').width();

        store.dispatch({
            type: 'VERRIERE_INIT',
            canvasWidth: parseInt(baseWidth, 10),
            canvasHeight: parseInt(baseWidth * (this.height / this.width), 10),
            baseImageHeight: this.height,
            baseImageWidth: this.width
        });

        $('.js-select-travee-or-traverse').change();
    };
    imageBase.src = $('#js-image-transparent').attr('src');
});

